/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BugReport": () => (/* reexport */ BugReport),
  "CSAT": () => (/* reexport */ CSAT),
  "Feedback": () => (/* reexport */ Feedback),
  "FeedbackThumbs": () => (/* reexport */ FeedbackThumbs),
  "HomologCSAT": () => (/* reexport */ HomologCSAT),
  "NPS": () => (/* reexport */ NPS),
  "getFeedbackBaseAPIURL": () => (/* reexport */ getFeedbackBaseAPIURL),
  "isValidFeedbackCategory": () => (/* reexport */ isValidFeedbackCategory),
  "validateBugReport": () => (/* reexport */ validateBugReport),
  "validateCSAT": () => (/* reexport */ validateCSAT),
  "validateFeedback": () => (/* reexport */ validateFeedback),
  "validateFeedbackThumbs": () => (/* reexport */ validateFeedbackThumbs),
  "validateHomologCSAT": () => (/* reexport */ validateHomologCSAT),
  "validateNPS": () => (/* reexport */ validateNPS)
});

;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// CONCATENATED MODULE: external "@andes/button"
const button_namespaceObject = require("@andes/button");
var button_default = /*#__PURE__*/__webpack_require__.n(button_namespaceObject);
;// CONCATENATED MODULE: external "@andes/progress-indicator-circular"
const progress_indicator_circular_namespaceObject = require("@andes/progress-indicator-circular");
;// CONCATENATED MODULE: external "form-serialize"
const external_form_serialize_namespaceObject = require("form-serialize");
var external_form_serialize_default = /*#__PURE__*/__webpack_require__.n(external_form_serialize_namespaceObject);
;// CONCATENATED MODULE: ./src/utils/helpers.js
const getCurrentUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.location.href;
};
;// CONCATENATED MODULE: ./src/Feedback/components/FeedbackForm/index.js
var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const FeedbackForm = _ref => {
  let {
    children,
    onSend
  } = _ref;
  const submit = e => {
    e.preventDefault();
    const form = e.target;
    const data = external_form_serialize_default()(form, {
      hash: true
    });

    /**
     * We use the parser(stringfy()) techinique here
     * to remove all key: undefined|null pairs from JSON.
     * The hard coded undefined ones are here by "doc" reasons.
     * The other ones may occur on additional_info
     */
    const result = JSON.parse(JSON.stringify({
      category: 'FEEDBACK_GERAL',
      section: data.section,
      site_id: undefined,
      key: data.key,
      value: data.value,
      user_id: undefined,
      validator: 'FeedbackGeral',
      additional_info: {
        reasons: data.reasons,
        language: undefined,
        comment: data.comment,
        url: getCurrentUrl()
      }
    }));
    if (onSend) {
      onSend(result);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "feedback-v3"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "feedback-v3__div--center"
  }, void 0, /*#__PURE__*/_jsx("form", {
    onSubmit: submit
  }, void 0, children)));
};
;// CONCATENATED MODULE: ./src/Feedback/components/StepTitle/index.js
var StepTitle_REACT_ELEMENT_TYPE;
function StepTitle_jsx(e, r, E, l) { StepTitle_REACT_ELEMENT_TYPE || (StepTitle_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: StepTitle_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const StepTitle = _ref => {
  let {
    i18n,
    title,
    subtitle
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/StepTitle_jsx("h2", {
    className: "feedback-v3__title"
  }, void 0, i18n.gettext(title)), /*#__PURE__*/StepTitle_jsx("p", {
    className: "feedback-v3__title-text"
  }, void 0, i18n.gettext(subtitle)));
};
;// CONCATENATED MODULE: external "@andes/radio-button"
const radio_button_namespaceObject = require("@andes/radio-button");
var radio_button_default = /*#__PURE__*/__webpack_require__.n(radio_button_namespaceObject);
;// CONCATENATED MODULE: ./src/Feedback/components/AskSatisfaction/index.js
var AskSatisfaction_REACT_ELEMENT_TYPE;
function AskSatisfaction_jsx(e, r, E, l) { AskSatisfaction_REACT_ELEMENT_TYPE || (AskSatisfaction_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: AskSatisfaction_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const AskSatisfaction = _ref => {
  let {
    i18n,
    onChange,
    question,
    value
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, Boolean(question) && /*#__PURE__*/AskSatisfaction_jsx("h3", {
    className: "feedback-v3__question"
  }, void 0, question === null || question === void 0 ? void 0 : question.label), /*#__PURE__*/AskSatisfaction_jsx("input", {
    type: "hidden",
    name: "key",
    defaultValue: question === null || question === void 0 ? void 0 : question.name
  }), /*#__PURE__*/AskSatisfaction_jsx(radio_button_namespaceObject.RadioGroup, {
    name: "value",
    onChange: event => onChange(event.target.value),
    value: value
  }, void 0, /*#__PURE__*/AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy insatisfecho(a)'),
    value: "veryDissatisfied"
  }), /*#__PURE__*/AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Insatisfecho(a)'),
    value: "dissatisfied"
  }), /*#__PURE__*/AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Ni satisfecho(a) ni insatisfecho(a)'),
    value: "neutral"
  }), /*#__PURE__*/AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Satisfecho(a)'),
    value: "satisfied"
  }), /*#__PURE__*/AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy satisfecho(a)'),
    value: "verySatisfied"
  })));
};
;// CONCATENATED MODULE: external "@andes/textfield"
const textfield_namespaceObject = require("@andes/textfield");
var textfield_default = /*#__PURE__*/__webpack_require__.n(textfield_namespaceObject);
;// CONCATENATED MODULE: external "@andes/checkbox"
const checkbox_namespaceObject = require("@andes/checkbox");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_namespaceObject);
;// CONCATENATED MODULE: ./src/Feedback/constants.js
const neutralScore = 'neutral';
const dynamicJustification = 5;
const mainPageSections = (/* unused pure expression or super */ null && ([['documentation', 'Documentación ', '¿Qué tan satisfecho(a) estás con las documentaciones?'], ['tutorial_video', 'Videos y tutoriales ', '¿Qué tan satisfecho(a) estás con nuestros videos tutoriales?'], ['sdk', 'SDK', '¿Qué tan satisfecho(a) estás con los SDKs?'], ['api_reference', 'Refêrencias API', '¿Qué tan satisfecho(a) estás con la página de Referencia de API?'], ['test_account', 'Cuenta de prueba', '¿Qué tan satisfecho(a) estás con las cuentas de prueba de tu integración?'], ['test_credit_card', 'Tarjeta de prueba', '¿Qué tan satisfecho(a) estás con las tarjetas de prueba?'], ['credentials', 'Credenciales', '¿Cuán satisfecho(a) estás con las credenciales?'], ['live_demo', 'Demostración', '¿Qué tan satisfecho(a) estás con la herramienta de demostración (Live demo) de Checkout?'], ['integration_quality', 'Calidad de la integración', '¿Cuán satisfecho(a) estás con la herramienta de prueba de calidad de integración?']]));
;// CONCATENATED MODULE: ./src/Feedback/components/AskSatisfactionReason/index.js
var AskSatisfactionReason_REACT_ELEMENT_TYPE;
function AskSatisfactionReason_jsx(e, r, E, l) { AskSatisfactionReason_REACT_ELEMENT_TYPE || (AskSatisfactionReason_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: AskSatisfactionReason_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const AskSatisfactionReason = _ref => {
  let {
    i18n,
    satisfaction,
    step,
    section,
    STEPS
  } = _ref;
  const [showDescribeReason, setDescribeReason] = (0,external_react_namespaceObject.useState)(false);
  let checkboxes = [];
  if (step !== 2) {
    var _STEPS$step;
    checkboxes = (_STEPS$step = STEPS[step]) === null || _STEPS$step === void 0 ? void 0 : _STEPS$step.checkboxes[satisfaction];
  } else {
    var _STEPS$step2;
    checkboxes = (_STEPS$step2 = STEPS[step]) === null || _STEPS$step2 === void 0 ? void 0 : _STEPS$step2.checkboxes[satisfaction][section];
  }
  const onChangeCheckbox = (e, checkbox) => {
    if (checkbox.name === 'Otros. ¿Cuáles?') {
      setDescribeReason(e.target.checked);
    }
  };
  if (satisfaction !== neutralScore) {
    return /*#__PURE__*/AskSatisfactionReason_jsx("div", {
      className: "feedback-v3-checkbox"
    }, void 0, /*#__PURE__*/AskSatisfactionReason_jsx("h2", {
      className: "feedback-v3-checkbox__title"
    }, void 0, i18n.gettext('Elige cuál de las alternativas que siguen explica el motivo de tu nota:')), Array.from(Object.keys(checkboxes)).map(item => {
      const checkbox = checkboxes[item];
      return /*#__PURE__*/AskSatisfactionReason_jsx((checkbox_default()), {
        label: i18n.gettext(checkbox.label),
        onChange: e => onChangeCheckbox(e, checkbox),
        inputProps: {
          value: checkbox.name,
          title: checkbox.label,
          name: 'reasons[]'
        }
      }, checkbox.name);
    }), showDescribeReason && /*#__PURE__*/AskSatisfactionReason_jsx((textfield_default()), {
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  if (satisfaction === neutralScore) {
    return /*#__PURE__*/AskSatisfactionReason_jsx("div", {
      className: "feedback-v3-comment"
    }, void 0, /*#__PURE__*/AskSatisfactionReason_jsx("h2", {
      className: "feedback-v3-comment__title"
    }, void 0, i18n.gettext('Por favor, descríbenos cómo fue usar nuestro sitio. Puedes dejarnos sugerencias sobre cómo podemos mejorar, si las tienes.')), /*#__PURE__*/AskSatisfactionReason_jsx((textfield_default()), {
      className: "feedback-v3__textfield",
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  return null;
};
;// CONCATENATED MODULE: external "@andes/dropdown"
const dropdown_namespaceObject = require("@andes/dropdown");
;// CONCATENATED MODULE: ./src/Feedback/components/AskSatisfactionBySection/index.js
var AskSatisfactionBySection_REACT_ELEMENT_TYPE;
function AskSatisfactionBySection_jsx(e, r, E, l) { AskSatisfactionBySection_REACT_ELEMENT_TYPE || (AskSatisfactionBySection_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: AskSatisfactionBySection_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const AskSatisfactionBySection = _ref => {
  let {
    i18n,
    onChange,
    section,
    changeSection,
    SECTIONS
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/AskSatisfactionBySection_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "section",
    menuMaxHeight: 250,
    value: section,
    placeholder: "Selecione uma op\xE7\xE3o",
    label: i18n.gettext('Elige qué sección del sitio quieres evaluar:'),
    onChange: event => changeSection(event.target.value)
  }, void 0, SECTIONS.map(ele => /*#__PURE__*/AskSatisfactionBySection_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[1],
    value: ele[0]
  }, ele[0]))), /*#__PURE__*/AskSatisfactionBySection_jsx("input", {
    type: "hidden",
    name: "section",
    defaultValue: section
  }), /*#__PURE__*/AskSatisfactionBySection_jsx("input", {
    type: "hidden",
    name: "key",
    defaultValue: SECTIONS.find(ele => ele[0] === section)[3]
  }), /*#__PURE__*/AskSatisfactionBySection_jsx("p", {
    className: "feedback-v3__question"
  }, void 0, SECTIONS.find(ele => ele[0] === section)[2]), /*#__PURE__*/AskSatisfactionBySection_jsx(AskSatisfaction, {
    i18n: i18n,
    onChange: onChange
  }));
};
;// CONCATENATED MODULE: external "@andes/icons/FeedbackPositive24"
const FeedbackPositive24_namespaceObject = require("@andes/icons/FeedbackPositive24");
var FeedbackPositive24_default = /*#__PURE__*/__webpack_require__.n(FeedbackPositive24_namespaceObject);
;// CONCATENATED MODULE: ./src/Feedback/components/ThankYou/index.js
var _FeedbackPositive;
var ThankYou_REACT_ELEMENT_TYPE;
function ThankYou_jsx(e, r, E, l) { ThankYou_REACT_ELEMENT_TYPE || (ThankYou_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ThankYou_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const ThankYou = _ref => {
  let {
    i18n,
    onGoAgain,
    onGoBeginning
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ThankYou_jsx("div", {
    className: "feedback-v3-appreciation__wrapper"
  }, void 0, _FeedbackPositive || (_FeedbackPositive = /*#__PURE__*/ThankYou_jsx((FeedbackPositive24_default()), {
    color: "#00A650"
  })), /*#__PURE__*/ThankYou_jsx("h1", {
    className: "feedback-v3-appreciation__title"
  }, void 0, i18n.gettext('Agradecemos tu opinión'))), /*#__PURE__*/ThankYou_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/ThankYou_jsx("p", {
    className: "feedback-v3-appreciation__text"
  }, void 0, i18n.gettext('¡Tu feedback nos ayuda a mejorar lo que ofrecemos!'))), /*#__PURE__*/ThankYou_jsx("div", {
    className: "feedback-v3-appreciation__wrapper"
  }, void 0, /*#__PURE__*/ThankYou_jsx((button_default()), {
    onClick: onGoAgain
  }, void 0, i18n.gettext('Volver a evaluar')), /*#__PURE__*/ThankYou_jsx("div", {
    style: {
      marginLeft: 10
    }
  }, void 0, /*#__PURE__*/ThankYou_jsx((button_default()), {
    hierarchy: "quiet",
    onClick: onGoBeginning
  }, void 0, i18n.gettext('Ir al inicio')))));
};
;// CONCATENATED MODULE: ./src/Feedback/components/StepLabel/index.js
var StepLabel_REACT_ELEMENT_TYPE;
function StepLabel_jsx(e, r, E, l) { StepLabel_REACT_ELEMENT_TYPE || (StepLabel_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: StepLabel_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const StepLabel = _ref => {
  let {
    i18n,
    step
  } = _ref;
  return /*#__PURE__*/StepLabel_jsx("p", {
    className: "feedback-v3__page-count"
  }, void 0, i18n.gettext('Pregunta {0} de 3', String(step + 1)));
};
;// CONCATENATED MODULE: ./src/utils/i18nNOOP.js
const i18nNOOP = {
  gettext: n => n
};
;// CONCATENATED MODULE: ./src/Feedback/texts.js
function getTexts(i18n) {
  const CHECKS1 = {
    NEUTRAL: [],
    SATISFIED: [{
      name: 'Me pareció fácil entender cómo funcionan los productos de Mercado Pago.',
      label: i18n.gettext('Me pareció fácil entender cómo funcionan los productos de Mercado Pago.')
    }, {
      name: 'Encontré todos los datos para empezar o terminar mi integración.',
      label: i18n.gettext('Encontré todos los datos para empezar o terminar mi integración.')
    }, {
      name: 'Me pareció fácil entender cómo hacer mi integración.',
      label: i18n.gettext('Me pareció fácil entender cómo hacer mi integración.')
    }, {
      name: 'Me pareció fácil entender cómo funciona el <dev>program.',
      label: i18n.gettext('Me pareció fácil entender cómo funciona el <dev>program.')
    }, {
      name: 'Otros. ¿Cuáles?',
      label: i18n.gettext('Otros. ¿Cuáles?')
    }],
    DISSATISFIED: [{
      name: 'Me pareció difícil entender cómo funcionan los productos de Mercado Pago Developers.',
      label: i18n.gettext('Me pareció difícil entender cómo funcionan los productos de Mercado Pago Developers.')
    }, {
      name: 'Me pareció difícil entender por dónde empezar y/o terminar mi integración.',
      label: i18n.gettext('Me pareció difícil entender por dónde empezar y/o terminar mi integración.')
    }, {
      name: 'Me pareció difícil entender cómo hacer mi integración.',
      label: i18n.gettext('Me pareció difícil entender cómo hacer mi integración.')
    }, {
      name: 'Me pareció difícil entender cómo funciona el <dev>program.',
      label: i18n.gettext('Me pareció difícil entender cómo funciona el <dev>program.')
    }, {
      name: 'Otros. ¿Cuáles?',
      label: i18n.gettext('Otros. ¿Cuáles?')
    }]
  };
  const CHECKS2 = {
    NEUTRAL: [],
    SATISFIED: [{
      name: 'Me pareció fácil encontrar dónde crear mi aplicación.',
      label: i18n.gettext('Me pareció fácil encontrar dónde crear mi aplicación.')
    }, {
      name: 'La explicación sobre cómo crear mi aplicación fue suficiente.',
      label: i18n.gettext('La explicación sobre cómo crear mi aplicación fue suficiente.')
    }, {
      name: 'Me pareció fácil usar las credenciales de producción o de prueba.',
      label: i18n.gettext('Me pareció fácil usar las credenciales de producción o de prueba.')
    }, {
      name: 'Me pareció fácil usar la herramienta de calidad de integración o hacer las mejoras propuestas.',
      label: i18n.gettext('Me pareció fácil usar la herramienta de calidad de integración o hacer las mejoras propuestas.')
    }, {
      name: 'Otros. ¿Cuáles?',
      label: i18n.gettext('Otros. ¿Cuáles?')
    }],
    DISSATISFIED: [{
      name: 'Me pareció difícil encontrar dónde crear mi aplicación.',
      label: i18n.gettext('Me pareció difícil encontrar dónde crear mi aplicación.')
    }, {
      name: 'Me quedé con dudas durante el proceso de creación de mi aplicación.',
      label: i18n.gettext('Me quedé con dudas durante el proceso de creación de mi aplicación.')
    }, {
      name: 'No entendí cómo usar las credenciales de producción o de prueba.',
      label: i18n.gettext('No entendí cómo usar las credenciales de producción o de prueba.')
    }, {
      name: 'Me pareció difícil usar la herramienta de calidad de la integración o hacer las mejoras propuestas.',
      label: i18n.gettext('Me pareció difícil usar la herramienta de calidad de la integración o hacer las mejoras propuestas.')
    }, {
      name: 'Otros. ¿Cuáles?',
      label: i18n.gettext('Otros. ¿Cuáles?')
    }]
  };
  const CHECKS3 = {
    NEUTRAL: [],
    SATISFIED: {
      documentation: [{
        name: 'Me pareció fácil encontrar la documentación del producto que integré/estoy integrando.',
        label: i18n.gettext('Me pareció fácil encontrar la documentación del producto que integré/estoy integrando.')
      }, {
        name: 'Me pareció claro cómo empezar mi integración.',
        label: i18n.gettext('Me pareció claro cómo empezar mi integración.')
      }, {
        name: 'Los ejemplos me ayudaron en el proceso de integración.',
        label: i18n.gettext('Los ejemplos me ayudaron en el proceso de integración.')
      }, {
        name: 'Me pareció claro cuáles eran los próximos pasos del proceso de integración.',
        label: i18n.gettext('Me pareció claro cuáles eran los próximos pasos del proceso de integración.')
      }, {
        name: 'Me pareció fácil poner mi integración en producción.',
        label: i18n.gettext('Me pareció fácil poner mi integración en producción.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      tutorial_video: [{
        name: 'Me pareció fácil entender el contenido de los videos tutoriales.',
        label: i18n.gettext('Me pareció fácil entender el contenido de los videos tutoriales.')
      }, {
        name: 'Los videos tutoriales me parecieron útiles para entender los productos de Mercado Pago.',
        label: i18n.gettext('Los videos tutoriales me parecieron útiles para entender los productos de Mercado Pago.')
      }, {
        name: 'Me pareció fácil navegar entre los contenidos.',
        label: i18n.gettext('Me pareció fácil navegar entre los contenidos.')
      }, {
        name: 'Encontré la información que necesitaba en los videos.',
        label: i18n.gettext('Encontré la información que necesitaba en los videos.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      sdk: [{
        name: 'Me pareció fácil encontrar, en las documentaciones, los SDKs del producto que integré.',
        label: i18n.gettext('Me pareció fácil encontrar, en las documentaciones, los SDKs del producto que integré.')
      }, {
        name: 'Me pareció fácil encontrar los SDKs para el lenguaje que uso.',
        label: i18n.gettext('Me pareció fácil encontrar los SDKs para el lenguaje que uso.')
      }, {
        name: 'Tuve toda la información sobre cómo usar los SDKs en mi integración.',
        label: i18n.gettext('Tuve toda la información sobre cómo usar los SDKs en mi integración.')
      }, {
        name: 'Logré usar los SDKs.',
        label: i18n.gettext('Logré usar los SDKs.')
      }, {
        name: 'Los ejemplos de la página del SDK de mi productos fueron claros.',
        label: i18n.gettext('Los ejemplos de la página del SDK de mi productos fueron claros.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      api_reference: [{
        name: 'Me pareció fácil encontrar la página de Referencia de API.',
        label: i18n.gettext('Me pareció fácil encontrar la página de Referencia de API.')
      }, {
        name: 'Me pareció fácil encontrar las Referencias de API que necesitaba para mi integración.',
        label: i18n.gettext('Me pareció fácil encontrar las Referencias de API que necesitaba para mi integración.')
      }, {
        name: 'Encontré con facilidad las configuraciones que necesitaba para mi integración.',
        label: i18n.gettext('Encontré con facilidad las configuraciones que necesitaba para mi integración.')
      }, {
        name: 'La información fue clara y me ayudó en mi integración.',
        label: i18n.gettext('La información fue clara y me ayudó en mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      test_account: [{
        name: 'Me pareció fácil encontrar dónde crear una cuenta de prueba.',
        label: i18n.gettext('Me pareció fácil encontrar dónde crear una cuenta de prueba.')
      }, {
        name: 'Me pareció fácil usar las cuentas de prueba.',
        label: i18n.gettext('Me pareció fácil usar las cuentas de prueba.')
      }, {
        name: 'Entendí con facilidad cuándo usar una cuenta de prueba en el proceso de integración.',
        label: i18n.gettext('Entendí con facilidad cuándo usar una cuenta de prueba en el proceso de integración.')
      }, {
        name: 'Las cuentas de prueba atendieron a mis expectativas.',
        label: i18n.gettext('Las cuentas de prueba atendieron a mis expectativas.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      test_credit_card: [{
        name: 'Me pareció fácil encontrar las tarjetas de prueba.',
        label: i18n.gettext('Me pareció fácil encontrar las tarjetas de prueba.')
      }, {
        name: 'Me pareció fácil usar las tarjetas de prueba.',
        label: i18n.gettext('Me pareció fácil usar las tarjetas de prueba.')
      }, {
        name: 'Entendí con facilidad cuándo usar una tarjeta de prueba en el proceso de integración.',
        label: i18n.gettext('Entendí con facilidad cuándo usar una tarjeta de prueba en el proceso de integración.')
      }, {
        name: 'Las tarjetas de prueba atendieron a mis expectativas.',
        label: i18n.gettext('Las tarjetas de prueba atendieron a mis expectativas.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      credentials: [{
        name: 'Me pareció fácil compartir las credenciales.',
        label: i18n.gettext('Me pareció fácil compartir las credenciales.')
      }, {
        name: 'Me pareció fácil crear cobros incorrectos y no autorizados.',
        label: i18n.gettext('Me pareció fácil crear cobros incorrectos y no autorizados.')
      }, {
        name: 'Me pareció fácil encontrar información detallada sobre credenciales.',
        label: i18n.gettext('Me pareció fácil encontrar información detallada sobre credenciales.')
      }, {
        name: 'Me pareció fácil activar las credenciales.',
        label: i18n.gettext('Me pareció fácil activar las credenciales.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      live_demo: [{
        name: 'Me pareció fácil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció fácil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'La demostración de Checkout me ayudó en la integración.',
        label: i18n.gettext('La demostración de Checkout me ayudó en la integración.')
      }, {
        name: 'Fue fácil compartir el código generado por la demostración de Checkout.',
        label: i18n.gettext('Fue fácil compartir el código generado por la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      integration_quality: [{
        name: 'La información sobre cómo hacer la prueba de la integración es clara.',
        label: i18n.gettext('La información sobre cómo hacer la prueba de la integración es clara.')
      }, {
        name: 'La prueba de la integración me ayudó a integrar mejor.',
        label: i18n.gettext('La prueba de la integración me ayudó a integrar mejor.')
      }, {
        name: 'Me pareció fácil hacer los cambios sugeridos por la herramienta.',
        label: i18n.gettext('Me pareció fácil hacer los cambios sugeridos por la herramienta.')
      }, {
        name: 'Entendí el objetivo de hacer la prueba de mi integración.',
        label: i18n.gettext('Entendí el objetivo de hacer la prueba de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }]
    },
    DISSATISFIED: {
      documentation: [{
        name: 'Me pareció difícil encontrar la documentación del producto que estoy integrando.',
        label: i18n.gettext('Me pareció difícil encontrar la documentación del producto que estoy integrando.')
      }, {
        name: 'Me pareció difícil empezar mi integración.',
        label: i18n.gettext('Me pareció difícil empezar mi integración.')
      }, {
        name: 'Los ejemplos no eran claros o no había ejemplos en mi documentación.',
        label: i18n.gettext('Los ejemplos no eran claros o no había ejemplos en mi documentación.')
      }, {
        name: 'Me quedé con dudas sobre los próximos pasos del proceso de integración.',
        label: i18n.gettext('Me quedé con dudas sobre los próximos pasos del proceso de integración.')
      }, {
        name: 'Me pareció difícil poner mi integración en producción.',
        label: i18n.gettext('Me pareció difícil poner mi integración en producción.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      tutorial_video: [{
        name: 'Me pareció difícil entender el contenido de los videos tutoriales.',
        label: i18n.gettext('Me pareció difícil entender el contenido de los videos tutoriales.')
      }, {
        name: 'Los videos tutoriales no me ayudaron durante la integración que estoy haciendo.',
        label: i18n.gettext('Los videos tutoriales no me ayudaron durante la integración que estoy haciendo.')
      }, {
        name: 'Los videos tutoriales están desactualizados.',
        label: i18n.gettext('Los videos tutoriales están desactualizados.')
      }, {
        name: 'No encontré la información que necesitaba en los videos tutoriales.',
        label: i18n.gettext('No encontré la información que necesitaba en los videos tutoriales.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      sdk: [{
        name: 'Me pareció difícil encontrar, en las documentaciones, los SDKs del producto que integré.',
        label: i18n.gettext('Me pareció difícil encontrar, en las documentaciones, los SDKs del producto que integré.')
      }, {
        name: 'No encontré los SDKs para el lenguaje que uso.',
        label: i18n.gettext('No encontré los SDKs para el lenguaje que uso.')
      }, {
        name: 'Faltaba información sobre cómo usar los SDKs en mi integración.',
        label: i18n.gettext('Faltaba información sobre cómo usar los SDKs en mi integración.')
      }, {
        name: 'No logré usar los SDKs.',
        label: i18n.gettext('No logré usar los SDKs.')
      }, {
        name: 'Los ejemplos de la página del SDK de mi producto no fueron claros.',
        label: i18n.gettext('Los ejemplos de la página del SDK de mi producto no fueron claros.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      api_reference: [{
        name: 'Me pareció difícil encontrar la página de Referencia de API.',
        label: i18n.gettext('Me pareció difícil encontrar la página de Referencia de API.')
      }, {
        name: 'Me pareció difícil encontrar las referencias de API que necesitaba para mi integración.',
        label: i18n.gettext('Me pareció difícil encontrar las referencias de API que necesitaba para mi integración.')
      }, {
        name: 'No encontré las configuraciones que necesitaba para mi integración.',
        label: i18n.gettext('No encontré las configuraciones que necesitaba para mi integración.')
      }, {
        name: 'La información no era clara o no me ayudó en mi integración.',
        label: i18n.gettext('La información no era clara o no me ayudó en mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      test_account: [{
        name: 'Me pareció difícil encontrar dónde crear una cuenta de prueba.',
        label: i18n.gettext('Me pareció difícil encontrar dónde crear una cuenta de prueba.')
      }, {
        name: 'Me pareció difícil usar las cuentas de prueba.',
        label: i18n.gettext('Me pareció difícil usar las cuentas de prueba.')
      }, {
        name: 'No entendí cuándo usar una cuenta de prueba en el proceso de integración.',
        label: i18n.gettext('No entendí cuándo usar una cuenta de prueba en el proceso de integración.')
      }, {
        name: 'Las cuentas de prueba no atendieron a mis expectativas.',
        label: i18n.gettext('Las cuentas de prueba no atendieron a mis expectativas.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      test_credit_card: [{
        name: 'Me pareció difícil encontrar las tarjetas de prueba.',
        label: i18n.gettext('Me pareció difícil encontrar las tarjetas de prueba.')
      }, {
        name: 'Me pareció difícil usar las tarjetas de prueba.',
        label: i18n.gettext('Me pareció difícil usar las tarjetas de prueba.')
      }, {
        name: 'No entendí cuándo usar las tarjetas de prueba en el proceso de integración.',
        label: i18n.gettext('No entendí cuándo usar las tarjetas de prueba en el proceso de integración.')
      }, {
        name: 'Las tarjetas de prueba no atendieron a mis expectativas.',
        label: i18n.gettext('Las tarjetas de prueba no atendieron a mis expectativas.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      credentials: [{
        name: 'Me pareció difícil compartir mis credenciales.',
        label: i18n.gettext('Me pareció difícil compartir mis credenciales.')
      }, {
        name: 'Tuve dificultad con los cobros incorrectos o no autorizados.',
        label: i18n.gettext('Tuve dificultad con los cobros incorrectos o no autorizados.')
      }, {
        name: 'Me pareció difícil encontrar información detallada sobre credenciales.',
        label: i18n.gettext('Me pareció difícil encontrar información detallada sobre credenciales.')
      }, {
        name: 'Me pareció difícil activar las credenciales.',
        label: i18n.gettext('Me pareció difícil activar las credenciales.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      live_demo: [{
        name: 'Me pareció difícil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'No entendí cómo la demostración de Checkout me ayuda en la integración.',
        label: i18n.gettext('No entendí cómo la demostración de Checkout me ayuda en la integración.')
      }, {
        name: 'Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      integration_quality: [{
        name: 'La información sobre cómo hacer la prueba de la integración no es clara.',
        label: i18n.gettext('La información sobre cómo hacer la prueba de la integración no es clara.')
      }, {
        name: 'La prueba de la integración no me ayudó a entender mejor las integraciones.',
        label: i18n.gettext('La prueba de la integración no me ayudó a entender mejor las integraciones.')
      }, {
        name: 'Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.',
        label: i18n.gettext('Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.')
      }, {
        name: 'No entendí el objetivo de hacer la prueba de mi integración.',
        label: i18n.gettext('No entendí el objetivo de hacer la prueba de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }]
    }
  };
  const STEPS = [{
    title: i18n.gettext('Evalúa tu experiencia'),
    subtitle: i18n.gettext('Ayúdanos a mejorar la experiencia de nuestros productos y servicios respondiendo a la siguiente pregunta:'),
    question: {
      name: '¿Qué tan satisfecho(a) estás con Mercado Pago Developers?',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con Mercado Pago Developers?')
    },
    checkboxes: {
      veryDissatisfied: [{
        name: 'Me pareció difícil entender cómo funcionan los productos de Mercado Pago Developers.',
        label: i18n.gettext('Me pareció difícil entender cómo funcionan los productos de Mercado Pago Developers.')
      }, {
        name: 'Me pareció difícil entender por dónde empezar y/o terminar mi integración.',
        label: i18n.gettext('Me pareció difícil entender por dónde empezar y/o terminar mi integración.')
      }, {
        name: 'Me pareció difícil entender cómo hacer mi integración.',
        label: i18n.gettext('Me pareció difícil entender cómo hacer mi integración.')
      }, {
        name: 'Me pareció difícil entender cómo funciona el <dev>program.',
        label: i18n.gettext('Me pareció difícil entender cómo funciona el <dev>program.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      dissatisfied: CHECKS1.DISSATISFIED,
      neutral: CHECKS1.NEUTRAL,
      satisfied: CHECKS1.SATISFIED,
      verySatisfied: CHECKS1.SATISFIED
    }
  }, {
    title: i18n.gettext('Evalúa tu experiencia'),
    subtitle: i18n.gettext('Ayúdanos a mejorar la experiencia de nuestros productos y servicios respondiendo a la siguiente pregunta:'),
    question: {
      name: '¿Qué tan satisfecho(a) estás con la experiencia de tus integraciones?',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con la experiencia de tus integraciones?')
    },
    checkboxes: {
      veryDissatisfied: CHECKS2.DISSATISFIED,
      dissatisfied: CHECKS2.DISSATISFIED,
      neutral: CHECKS2.NEUTRAL,
      satisfied: CHECKS2.SATISFIED,
      verySatisfied: CHECKS2.SATISFIED
    }
  }, {
    title: i18n.gettext('Evalúa tu experiencia'),
    subtitle: i18n.gettext('Ayúdanos a mejorar la experiencia de nuestros productos y servicios respondiendo a la siguiente pregunta:'),
    question: {
      name: '¿Qué tan satisfecho(a) estás con las',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con las')
    },
    checkboxes: {
      veryDissatisfied: CHECKS3.DISSATISFIED,
      dissatisfied: CHECKS3.DISSATISFIED,
      neutral: CHECKS3.NEUTRAL,
      satisfied: CHECKS3.SATISFIED,
      verySatisfied: CHECKS3.SATISFIED
    }
  }];
  return STEPS;
}
function getSections(i18n) {
  return [['documentation', i18n.gettext('Documentación'), i18n.gettext('¿Qué tan satisfecho(a) estás con las documentaciones?'), '¿Qué tan satisfecho(a) estás con las documentaciones?'], ['tutorial_video', i18n.gettext('Videos y tutoriales'), i18n.gettext('¿Qué tan satisfecho(a) estás con nuestros videos tutoriales?'), '¿Qué tan satisfecho(a) estás con nuestros videos tutoriales?'], ['sdk', i18n.gettext('SDK'), i18n.gettext('¿Qué tan satisfecho(a) estás con los SDKs?'), '¿Qué tan satisfecho(a) estás con los SDKs?'], ['api_reference', i18n.gettext('Refêrencias API'), i18n.gettext('¿Qué tan satisfecho(a) estás con la página de Referencia de API?'), '¿Qué tan satisfecho(a) estás con la página de Referencia de API?'], ['test_account', i18n.gettext('Cuenta de prueba'), i18n.gettext('¿Qué tan satisfecho(a) estás con las cuentas de prueba de tu integración?'), '¿Qué tan satisfecho(a) estás con las cuentas de prueba de tu integración?'], ['test_credit_card', i18n.gettext('Tarjeta de prueba'), i18n.gettext('¿Qué tan satisfecho(a) estás con las tarjetas de prueba?'), '¿Qué tan satisfecho(a) estás con las tarjetas de prueba?'], ['credentials', i18n.gettext('Credenciales'), i18n.gettext('¿Cuán satisfecho(a) estás con las credenciales?'), '¿Cuán satisfecho(a) estás con las credenciales?'], ['live_demo', i18n.gettext('Demostración'), i18n.gettext('¿Qué tan satisfecho(a) estás con la herramienta de demostración (Live demo) de Checkout?'), '¿Qué tan satisfecho(a) estás con la herramienta de demostración (Live demo) de Checkout?'], ['integration_quality', i18n.gettext('Calidad de la integración'), i18n.gettext('¿Cuán satisfecho(a) estás con la herramienta de prueba de calidad de integración?'), '¿Cuán satisfecho(a) estás con la herramienta de prueba de calidad de integración?']];
}
;// CONCATENATED MODULE: ./src/Feedback/index.js
var _div;
var Feedback_REACT_ELEMENT_TYPE;
function Feedback_jsx(e, r, E, l) { Feedback_REACT_ELEMENT_TYPE || (Feedback_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: Feedback_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }












const Feedback = _ref => {
  let {
    i18n = i18nNOOP,
    onSend,
    texts
  } = _ref;
  const STEPS = texts || getTexts(i18n);
  const SECTIONS = getSections(i18n);
  const [step, setStep] = (0,external_react_namespaceObject.useState)(0);
  const [finished, setFinished] = (0,external_react_namespaceObject.useState)(false);
  const [loading, setLoading] = (0,external_react_namespaceObject.useState)(false);
  const [satisfaction, setSatisfaction] = (0,external_react_namespaceObject.useState)(null);
  const [section, setSection] = (0,external_react_namespaceObject.useState)(SECTIONS[0][0]);
  const [details, setDetails] = (0,external_react_namespaceObject.useState)(STEPS[step]);
  const send = data => {
    setLoading(true);
    const result = _objectSpread(_objectSpread({}, data), {}, {
      step
    });
    onSend(result).then(() => {
      /* istanbul ignore next */
      if (!finished) {
        setSatisfaction(null);
        setStep(step + 1);
        setLoading(false);
      }
    });
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    setDetails(STEPS[step]);
    setFinished(step > STEPS.length - 1);
  }, [step]);
  if (!finished) {
    return /*#__PURE__*/Feedback_jsx(FeedbackForm, {
      onSend: send
    }, void 0, /*#__PURE__*/Feedback_jsx(StepLabel, {
      i18n: i18n,
      step: step
    }), /*#__PURE__*/Feedback_jsx(StepTitle, {
      title: details.title,
      subtitle: details.subtitle,
      i18n: i18n
    }), step === 2 ? /*#__PURE__*/Feedback_jsx(AskSatisfactionBySection, {
      question: details.question,
      section: section,
      SECTIONS: SECTIONS,
      changeSection: setSection,
      onChange: setSatisfaction,
      i18n: i18n
    }) : /*#__PURE__*/Feedback_jsx(AskSatisfaction, {
      onChange: setSatisfaction,
      value: satisfaction,
      question: details.question,
      i18n: i18n
    }), Boolean(satisfaction) && /*#__PURE__*/Feedback_jsx("div", {
      className: "feedback-v3__actions"
    }, void 0, /*#__PURE__*/Feedback_jsx(AskSatisfactionReason, {
      step: step,
      satisfaction: satisfaction,
      section: section,
      STEPS: STEPS,
      i18n: i18n
    }), loading ? _div || (_div = /*#__PURE__*/Feedback_jsx("div", {
      className: "loading-holder"
    }, void 0, /*#__PURE__*/Feedback_jsx(progress_indicator_circular_namespaceObject.ProgressIndicatorCircular, {
      color: "blue",
      id: "progress-indicator-circular",
      modifier: "block",
      size: "small",
      srLabel: "Downloading file",
      type: "indeterminate"
    }))) : /*#__PURE__*/Feedback_jsx((button_default()), {
      type: "submit",
      disabled: loading
    }, void 0, step < STEPS.length ? i18n.gettext('Próximo') : i18n.gettext('Enviar'))));
  }
  return /*#__PURE__*/Feedback_jsx(FeedbackForm, {}, void 0, /*#__PURE__*/Feedback_jsx(ThankYou, {
    onGoAgain: /* istanbul ignore next */() => setStep(2),
    onGoBeginning: /* istanbul ignore next */() => setStep(0),
    i18n: i18n
  }));
};
;// CONCATENATED MODULE: ./src/CSAT/components/CSATform/index.js
var CSATform_REACT_ELEMENT_TYPE;
function CSATform_jsx(e, r, E, l) { CSATform_REACT_ELEMENT_TYPE || (CSATform_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CSATform_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const CSATform = _ref => {
  let {
    children,
    onSend
  } = _ref;
  const submit = e => {
    e.preventDefault();
    const form = e.target;
    const data = external_form_serialize_default()(form, {
      hash: true
    });

    /**
     * We use the parser(stringfy()) techinique here
     * to remove all key: undefined|null pairs from JSON.
     * The hard coded undefined ones are here by "doc" reasons.
     * The other ones may occur on additional_info
     */
    const result = JSON.parse(JSON.stringify({
      category: 'LIVEDEMO_CSAT',
      session: undefined,
      site_id: undefined,
      key: data.key,
      validator: 'CSAT',
      value: data.value,
      user_id: undefined,
      additional_info: {
        reasons: data.reasons,
        language: undefined,
        comment: data.comment,
        url: getCurrentUrl()
      }
    }));
    if (onSend) {
      onSend(result);
    }
  };
  return /*#__PURE__*/CSATform_jsx("div", {
    className: "csat-v3"
  }, void 0, /*#__PURE__*/CSATform_jsx("div", {
    className: "csat-v3__div--center"
  }, void 0, /*#__PURE__*/CSATform_jsx("form", {
    onSubmit: submit
  }, void 0, children)));
};
;// CONCATENATED MODULE: ./src/CSAT/components/CSATtitle/index.js
var CSATtitle_REACT_ELEMENT_TYPE;
function CSATtitle_jsx(e, r, E, l) { CSATtitle_REACT_ELEMENT_TYPE || (CSATtitle_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CSATtitle_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const CSATtitle = _ref => {
  let {
    i18n,
    title,
    subtitle,
    onClick
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/CSATtitle_jsx("h2", {
    className: "csat-v3__title"
  }, void 0, title), /*#__PURE__*/CSATtitle_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/CSATtitle_jsx("p", {
    className: "csat-v3__title-text"
  }, void 0, subtitle)), /*#__PURE__*/CSATtitle_jsx((button_default()), {
    "data-testid": "button-start",
    onClick: onClick,
    size: "medium"
  }, void 0, i18n.gettext('Empezar')));
};
;// CONCATENATED MODULE: ./src/CSAT/components/AskSatisfaction/index.js
var components_AskSatisfaction_REACT_ELEMENT_TYPE;
function components_AskSatisfaction_jsx(e, r, E, l) { components_AskSatisfaction_REACT_ELEMENT_TYPE || (components_AskSatisfaction_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_AskSatisfaction_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const AskSatisfaction_AskSatisfaction = _ref => {
  let {
    i18n,
    onChange,
    question,
    value
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, Boolean(question) && /*#__PURE__*/components_AskSatisfaction_jsx("h3", {
    className: "csat-v3__question"
  }, void 0, question === null || question === void 0 ? void 0 : question.label), /*#__PURE__*/components_AskSatisfaction_jsx("input", {
    type: "hidden",
    name: "key",
    defaultValue: question === null || question === void 0 ? void 0 : question.name
  }), /*#__PURE__*/components_AskSatisfaction_jsx(radio_button_namespaceObject.RadioGroup, {
    name: "value",
    onChange: event => onChange(event.target.value),
    value: value
  }, void 0, /*#__PURE__*/components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy insatisfecho(a)'),
    value: "veryDissatisfied"
  }), /*#__PURE__*/components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Insatisfecho(a)'),
    value: "dissatisfied"
  }), /*#__PURE__*/components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Ni satisfecho(a) ni insatisfecho(a)'),
    value: "neutral"
  }), /*#__PURE__*/components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Satisfecho(a)'),
    value: "satisfied"
  }), /*#__PURE__*/components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy satisfecho(a)'),
    value: "verySatisfied"
  })));
};
;// CONCATENATED MODULE: ./src/utils/constants.js
const constants_neutralScore = 'neutral';
const constants_dynamicJustification = 5;
const categories = ['NPS', 'LIVEDEMO_CSAT', 'FEEDBACK_GERAL', 'HOMOLOGATOR_CSAT', 'DOCS_SATISFACTION', 'BUG_REPORT'];
;// CONCATENATED MODULE: ./src/CSAT/components/AskSatisfactionReason/index.js
var components_AskSatisfactionReason_REACT_ELEMENT_TYPE;
function components_AskSatisfactionReason_jsx(e, r, E, l) { components_AskSatisfactionReason_REACT_ELEMENT_TYPE || (components_AskSatisfactionReason_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_AskSatisfactionReason_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const AskSatisfactionReason_AskSatisfactionReason = _ref => {
  let {
    i18n,
    satisfaction,
    step,
    section,
    STEPS
  } = _ref;
  const [showDescribeReason, setDescribeReason] = (0,external_react_namespaceObject.useState)(false);
  let checkboxes = [];
  if (step !== 2) {
    var _STEPS$step;
    checkboxes = (_STEPS$step = STEPS[step]) === null || _STEPS$step === void 0 ? void 0 : _STEPS$step.checkboxes[satisfaction];
  } else {
    var _STEPS$step2;
    checkboxes = (_STEPS$step2 = STEPS[step]) === null || _STEPS$step2 === void 0 ? void 0 : _STEPS$step2.checkboxes[satisfaction][section];
  }
  const onChangeCheckbox = (e, checkbox) => {
    if (checkbox.name === 'Otros. ¿Cuáles?') {
      setDescribeReason(e.target.checked);
    }
  };
  if (satisfaction !== constants_neutralScore) {
    return /*#__PURE__*/components_AskSatisfactionReason_jsx("div", {
      className: "csat-v3-checkbox"
    }, void 0, /*#__PURE__*/components_AskSatisfactionReason_jsx("h2", {
      className: "csat-v3-checkbox__title"
    }, void 0, i18n.gettext('Elige cuál de las alternativas que siguen explica el motivo de tu nota:')), Array.from(Object.keys(checkboxes)).map(item => {
      const checkbox = checkboxes[item];
      return /*#__PURE__*/components_AskSatisfactionReason_jsx((checkbox_default()), {
        label: i18n.gettext(checkbox.label),
        onChange: e => onChangeCheckbox(e, checkbox),
        inputProps: {
          value: checkbox.name,
          title: checkbox.label,
          name: 'reasons[]'
        }
      }, checkbox.name);
    }), showDescribeReason && /*#__PURE__*/components_AskSatisfactionReason_jsx((textfield_default()), {
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  if (satisfaction === constants_neutralScore) {
    return /*#__PURE__*/components_AskSatisfactionReason_jsx("div", {
      className: "csat-v3-comment"
    }, void 0, /*#__PURE__*/components_AskSatisfactionReason_jsx("h2", {
      className: "csat-v3-comment__title"
    }, void 0, i18n.gettext('Por favor, descríbenos cómo fue usar nuestro sitio. Puedes dejarnos sugerencias sobre cómo podemos mejorar, si las tienes.')), /*#__PURE__*/components_AskSatisfactionReason_jsx((textfield_default()), {
      className: "csat-v3__textfield",
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  return null;
};
;// CONCATENATED MODULE: ./src/CSAT/components/CSATthankYou/index.js
var CSATthankYou_FeedbackPositive;
var CSATthankYou_REACT_ELEMENT_TYPE;
function CSATthankYou_jsx(e, r, E, l) { CSATthankYou_REACT_ELEMENT_TYPE || (CSATthankYou_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CSATthankYou_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const CSATthankYou_ThankYou = _ref => {
  let {
    i18n,
    email,
    stepBack,
    onAcceptEmail,
    loginhref,
    gaprops
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/CSATthankYou_jsx("div", {
    className: "csat-v3-appreciation-csat__wrapper"
  }, void 0, CSATthankYou_FeedbackPositive || (CSATthankYou_FeedbackPositive = /*#__PURE__*/CSATthankYou_jsx((FeedbackPositive24_default()), {
    color: "#00A650"
  })), /*#__PURE__*/CSATthankYou_jsx("h1", {
    className: "csat-v3-appreciation-csat__title"
  }, void 0, i18n.gettext('Agradecemos tu colaboración.'))), /*#__PURE__*/CSATthankYou_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/CSATthankYou_jsx("p", {
    className: "csat-v3-appreciation-csat__subtitle"
  }, void 0, i18n.gettext('Tu evaluación nos ayuda a mejorar nuestros productos y servicios.'))), /*#__PURE__*/CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/CSATthankYou_jsx("h2", {
    className: "csat-v3-appreciation-csat__contact"
  }, void 0, i18n.gettext('¿Podemos contactarte por e-mail para entender mejor tu evaluación?'))), /*#__PURE__*/CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/CSATthankYou_jsx("p", {
    className: "csat-v3-appreciation-csat__text gray"
  }, void 0, i18n.gettext('Vamos a usar la dirección e-mail que ofreciste cuando te registraste.'))), /*#__PURE__*/CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/CSATthankYou_jsx("p", {
    className: "csat-v3-appreciation-csat__email normal"
  }, void 0, email)), /*#__PURE__*/CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/CSATthankYou_jsx("p", {
    className: "csat-v3-appreciation-csat__text normal"
  }, void 0, i18n.gettext('Al hacer clic en el botón "Sí, acepto", autorizo que Mercado Pago me contacte por e-mail para entender mejor mi evaluación.'))), /*#__PURE__*/CSATthankYou_jsx("div", {
    className: "csat-v3-appreciation-csat__wrapper"
  }, void 0, email === undefined ? /*#__PURE__*/CSATthankYou_jsx("a", {
    href: loginhref,
    "ga-props": gaprops
  }, void 0, /*#__PURE__*/CSATthankYou_jsx((button_default()), {
    onClick: () => {
      window.localStorage.setItem('redirectBack', true);
    }
  }, void 0, i18n.gettext('Sí, acepto'))) : /*#__PURE__*/CSATthankYou_jsx((button_default()), {
    onClick: onAcceptEmail
  }, void 0, i18n.gettext('Sí, acepto')), /*#__PURE__*/CSATthankYou_jsx("div", {
    style: {
      marginLeft: 10
    }
  }, void 0, /*#__PURE__*/CSATthankYou_jsx((button_default()), {
    hierarchy: "quiet",
    type: "submit",
    onClick: stepBack,
    "data-testid": "button-end"
  }, void 0, i18n.gettext('Terminar')))));
};
;// CONCATENATED MODULE: ./src/CSAT/texts.js
/* eslint-disable max-len */
// Nos campos com label e name, o name é enviado para o banco de dados, e armazena em uma unica lingua as justificativas do feedback
// O label é usado para traduzir com o i18n.

function texts_getTexts(i18n) {
  return [{
    title: i18n.gettext('¿Tienes 2 minutos para darnos tu feedback?'),
    subtitle: i18n.gettext('Nos encantaría saber más de tu experiencia dentro de Mercado Pago Developers')
  }, {
    question: {
      name: '¿Qué tan satisfecho(a) estás con la herramienta de demostración (Live demo) de Checkout?',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con la herramienta de demostración (Live demo) de Checkout?')
    },
    checkboxes: {
      veryDissatisfied: [{
        name: 'Me pareció difícil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'No entendí cómo la demostración de Checkout me ayuda en la integración.',
        label: i18n.gettext('No entendí cómo la demostración de Checkout me ayuda en la integración.')
      }, {
        name: 'Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      dissatisfied: [{
        name: 'Me pareció difícil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'No entendí cómo la demostración de Checkout me ayuda en la integración.',
        label: i18n.gettext('No entendí cómo la demostración de Checkout me ayuda en la integración.')
      }, {
        name: 'Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.',
        label: i18n.gettext('Me pareció difícil integrar el código copiado o descargado de la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      neutral: [],
      satisfied: [{
        name: 'Me pareció fácil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció fácil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'La demostración de Checkout me ayudó en la integración.',
        label: i18n.gettext('La demostración de Checkout me ayudó en la integración.')
      }, {
        name: 'Me pareció fácil integrar el código copiado o descargado de la demostración de Checkout.',
        label: i18n.gettext('Me pareció fácil integrar el código copiado o descargado de la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      verySatisfied: [{
        name: 'Me pareció fácil usar la herramienta de demostración de Checkout.',
        label: i18n.gettext('Me pareció fácil usar la herramienta de demostración de Checkout.')
      }, {
        name: 'La demostración de Checkout me ayudó en la integración.',
        label: i18n.gettext('La demostración de Checkout me ayudó en la integración.')
      }, {
        name: 'Me pareció fácil integrar el código copiado o descargado de la demostración de Checkout.',
        label: i18n.gettext('Me pareció fácil integrar el código copiado o descargado de la demostración de Checkout.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }]
    }
  }];
}
;// CONCATENATED MODULE: ./src/CSAT/index.js
var CSAT_REACT_ELEMENT_TYPE;
function CSAT_jsx(e, r, E, l) { CSAT_REACT_ELEMENT_TYPE || (CSAT_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CSAT_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function CSAT_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CSAT_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CSAT_ownKeys(Object(t), !0).forEach(function (r) { CSAT_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CSAT_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CSAT_defineProperty(e, r, t) { return (r = CSAT_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function CSAT_toPropertyKey(t) { var i = CSAT_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function CSAT_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









const CSAT = _ref => {
  let {
    i18n = i18nNOOP,
    texts,
    onSend,
    email,
    onAcceptEmail = () => console.log('email aceitado'),
    loginhref,
    gaprops
  } = _ref;
  const STEPS = texts || texts_getTexts(i18n);
  const [step, setStep] = (0,external_react_namespaceObject.useState)(window.localStorage.getItem('redirectBack') === true ? 2 : 0);
  const [satisfaction, setSatisfaction] = (0,external_react_namespaceObject.useState)(null);
  const [details, setDetails] = (0,external_react_namespaceObject.useState)(STEPS[step]);
  const send = data => {
    const result = CSAT_objectSpread(CSAT_objectSpread({}, data), {}, {
      step
    });
    setStep(step + 1);
    if (onSend) {
      setSatisfaction(null);
      onSend(result);
    }
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    setDetails(STEPS[step]);
  }, [step]);

  /* istanbul ignore next */
  (0,external_react_namespaceObject.useEffect)(() => {
    window.localStorage.removeItem('redirectBack');
  });

  /* istanbul ignore next */
  function acceptFunctions() {
    onAcceptEmail();
    setStep(1);
  }
  return /*#__PURE__*/CSAT_jsx(CSATform, {
    onSend: send
  }, void 0, step === 0 && /*#__PURE__*/CSAT_jsx(CSATtitle, {
    title: details.title,
    subtitle: details.subtitle,
    onClick: () => setStep(step + 1),
    i18n: i18n
  }), step === 1 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/CSAT_jsx(AskSatisfaction_AskSatisfaction, {
    onChange: setSatisfaction,
    value: satisfaction,
    question: details === null || details === void 0 ? void 0 : details.question,
    i18n: i18n
  }), Boolean(satisfaction) && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/CSAT_jsx(AskSatisfactionReason_AskSatisfactionReason, {
    step: step,
    satisfaction: satisfaction,
    STEPS: STEPS,
    i18n: i18n
  }), /*#__PURE__*/CSAT_jsx((button_default()), {
    type: "submit"
  }, void 0, i18n.gettext('Enviar')))), step === 2 && /*#__PURE__*/CSAT_jsx(CSATthankYou_ThankYou, {
    stepBack: () => setStep(1),
    i18n: i18n,
    email: email,
    loginhref: loginhref,
    gaprops: gaprops,
    onAcceptEmail: acceptFunctions
  }));
};
;// CONCATENATED MODULE: ./src/HomologCSAT/components/CSATform/index.js
var components_CSATform_REACT_ELEMENT_TYPE;
function components_CSATform_jsx(e, r, E, l) { components_CSATform_REACT_ELEMENT_TYPE || (components_CSATform_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_CSATform_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const CSATform_CSATform = _ref => {
  let {
    children,
    onSend,
    step
  } = _ref;
  const submit = e => {
    e.preventDefault();
    const form = e.target;
    const data = external_form_serialize_default()(form, {
      hash: true
    });

    /**
     * We use the parser(stringfy()) techinique here
     * to remove all key: undefined|null pairs from JSON.
     * The hard coded undefined ones are here by "doc" reasons.
     * The other ones may occur on additional_info
     */
    const result = JSON.parse(JSON.stringify({
      category: 'HOMOLOGATOR_CSAT',
      session: undefined,
      site_id: undefined,
      key: data.key,
      value: data.value,
      user_id: undefined,
      validator: 'HomologCSAT',
      additional_info: {
        reasons: data.reasons,
        language: undefined,
        comment: data.comment,
        url: getCurrentUrl()
      }
    }));
    if (onSend) {
      onSend(result);
    }
  };
  return /*#__PURE__*/components_CSATform_jsx("div", {
    className: "homolcsat-v3 csat-size ".concat(step === 0 ? 'weakGray' : '')
  }, void 0, /*#__PURE__*/components_CSATform_jsx("div", {
    className: "homolcsat-v3__div--center"
  }, void 0, /*#__PURE__*/components_CSATform_jsx("form", {
    onSubmit: submit
  }, void 0, children)));
};
;// CONCATENATED MODULE: external "@andes/badge"
const badge_namespaceObject = require("@andes/badge");
;// CONCATENATED MODULE: ./src/HomologCSAT/components/CSATStart/index.js
var _Pill;
var CSATStart_REACT_ELEMENT_TYPE;
function CSATStart_jsx(e, r, E, l) { CSATStart_REACT_ELEMENT_TYPE || (CSATStart_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: CSATStart_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const CSATStart = _ref => {
  let {
    i18n,
    title,
    subtitle,
    evaluateAgainBTN,
    nextStep
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/CSATStart_jsx("div", {
    className: "homolcsat-v3-start__wrapper--title"
  }, void 0, _Pill || (_Pill = /*#__PURE__*/CSATStart_jsx(badge_namespaceObject.Pill, {
    contentType: "icon",
    size: "large",
    color: "orange"
  })), /*#__PURE__*/CSATStart_jsx("h2", {
    className: "homolcsat-v3-start__title weakBlack"
  }, void 0, title)), /*#__PURE__*/CSATStart_jsx("div", {
    className: "homolcsat-v3-start__div--text"
  }, void 0, /*#__PURE__*/CSATStart_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/CSATStart_jsx("p", {
    className: "homolcsat-v3-start__subtitle gray"
  }, void 0, subtitle)), /*#__PURE__*/CSATStart_jsx("div", {
    className: "homolcsat-v3-start__wrapper--button"
  }, void 0, /*#__PURE__*/CSATStart_jsx((button_default()), {
    onClick: evaluateAgainBTN
  }, void 0, i18n.gettext('Volver a evaluar')), /*#__PURE__*/CSATStart_jsx("div", {
    style: {
      marginLeft: 10
    }
  }, void 0, /*#__PURE__*/CSATStart_jsx((button_default()), {
    type: "button",
    onClick: nextStep,
    hierarchy: "transparent"
  }, void 0, i18n.gettext('Terminar'))))));
};
;// CONCATENATED MODULE: ./src/HomologCSAT/components/AskSatisfaction/index.js
var HomologCSAT_components_AskSatisfaction_REACT_ELEMENT_TYPE;
function HomologCSAT_components_AskSatisfaction_jsx(e, r, E, l) { HomologCSAT_components_AskSatisfaction_REACT_ELEMENT_TYPE || (HomologCSAT_components_AskSatisfaction_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: HomologCSAT_components_AskSatisfaction_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const components_AskSatisfaction_AskSatisfaction = _ref => {
  let {
    i18n,
    onChange,
    question,
    value
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, Boolean(question) && /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx("h3", {
    className: "homolcsat-v3__question"
  }, void 0, question === null || question === void 0 ? void 0 : question.label), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx("input", {
    type: "hidden",
    name: "key",
    defaultValue: question === null || question === void 0 ? void 0 : question.name
  }), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx(radio_button_namespaceObject.RadioGroup, {
    name: "value",
    onChange: event => onChange(event.target.value),
    value: value
  }, void 0, /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy insatisfecho(a)'),
    value: "veryDissatisfied"
  }), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Insatisfecho(a)'),
    value: "dissatisfied"
  }), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Ni satisfecho(a) ni insatisfecho(a)'),
    value: "neutral"
  }), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Satisfecho(a)'),
    value: "satisfied"
  }), /*#__PURE__*/HomologCSAT_components_AskSatisfaction_jsx((radio_button_default()), {
    label: i18n.gettext('Muy satisfecho(a)'),
    value: "verySatisfied"
  })));
};
;// CONCATENATED MODULE: ./src/HomologCSAT/components/AskSatisfactionReason/index.js
var HomologCSAT_components_AskSatisfactionReason_REACT_ELEMENT_TYPE;
function HomologCSAT_components_AskSatisfactionReason_jsx(e, r, E, l) { HomologCSAT_components_AskSatisfactionReason_REACT_ELEMENT_TYPE || (HomologCSAT_components_AskSatisfactionReason_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: HomologCSAT_components_AskSatisfactionReason_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const components_AskSatisfactionReason_AskSatisfactionReason = _ref => {
  let {
    i18n,
    satisfaction,
    step,
    section,
    STEPS
  } = _ref;
  const [showDescribeReason, setDescribeReason] = (0,external_react_namespaceObject.useState)(false);
  let checkboxes = [];
  if (step !== 2) {
    var _STEPS$step;
    checkboxes = (_STEPS$step = STEPS[step]) === null || _STEPS$step === void 0 ? void 0 : _STEPS$step.checkboxes[satisfaction];
  } else {
    var _STEPS$step2;
    checkboxes = (_STEPS$step2 = STEPS[step]) === null || _STEPS$step2 === void 0 ? void 0 : _STEPS$step2.checkboxes[satisfaction][section];
  }
  const onChangeCheckbox = (e, checkbox) => {
    if (checkbox.name === 'Otros. ¿Cuáles?') {
      setDescribeReason(e.target.checked);
    }
  };
  if (satisfaction !== constants_neutralScore) {
    return /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx("div", {
      className: "homolcsat-v3-checkbox"
    }, void 0, /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx("h2", {
      className: "homolcsat-v3-checkbox__title"
    }, void 0, i18n.gettext('Elige cuál de las alternativas que siguen explica el motivo de tu nota:')), Array.from(Object.keys(checkboxes)).map(item => {
      const checkbox = checkboxes[item];
      return /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx((checkbox_default()), {
        label: i18n.gettext(checkbox.label),
        onChange: e => onChangeCheckbox(e, checkbox),
        inputProps: {
          value: checkbox.name,
          title: checkbox.label,
          name: 'reasons[]'
        }
      }, checkbox.name);
    }), showDescribeReason && /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx((textfield_default()), {
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  if (satisfaction === constants_neutralScore) {
    return /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx("div", {
      className: "homolcsat-v3-comment"
    }, void 0, /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx("h2", {
      className: "homolcsat-v3-comment__title"
    }, void 0, i18n.gettext('Por favor, descríbenos cómo fue usar nuestro sitio. Puedes dejarnos sugerencias sobre cómo podemos mejorar, si las tienes.')), /*#__PURE__*/HomologCSAT_components_AskSatisfactionReason_jsx((textfield_default()), {
      className: "homolcsat-v3__textfield",
      rows: "4",
      maxLength: "250",
      countdown: true,
      multiline: true,
      name: "comment",
      label: i18n.gettext('Comenta aquí')
    }));
  }
  return null;
};
;// CONCATENATED MODULE: ./src/HomologCSAT/components/CSATthankYou/index.js
var components_CSATthankYou_FeedbackPositive;
var components_CSATthankYou_REACT_ELEMENT_TYPE;
function components_CSATthankYou_jsx(e, r, E, l) { components_CSATthankYou_REACT_ELEMENT_TYPE || (components_CSATthankYou_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_CSATthankYou_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const components_CSATthankYou_ThankYou = _ref => {
  let {
    i18n,
    email,
    onAcceptEmail,
    step,
    nextStep
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/components_CSATthankYou_jsx("div", {
    className: "homolcsat-v3-appreciation-csat__feedbackWrapper"
  }, void 0, components_CSATthankYou_FeedbackPositive || (components_CSATthankYou_FeedbackPositive = /*#__PURE__*/components_CSATthankYou_jsx((FeedbackPositive24_default()), {
    color: "#00A650"
  })), /*#__PURE__*/components_CSATthankYou_jsx("h1", {
    className: "homolcsat-v3-appreciation-csat__title"
  }, void 0, i18n.gettext('Agradecemos tu colaboración.'))), /*#__PURE__*/components_CSATthankYou_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/components_CSATthankYou_jsx("p", {
    className: "homolcsat-v3-appreciation-csat__subtitle"
  }, void 0, i18n.gettext('Tu evaluación nos ayuda a mejorar nuestros productos y servicios.'))), step === 2 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/components_CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/components_CSATthankYou_jsx("h2", {
    className: "homolcsat-v3-appreciation-csat__contact"
  }, void 0, i18n.gettext('¿Podemos contactarte por e-mail para entender mejor tu evaluación?'))), /*#__PURE__*/components_CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/components_CSATthankYou_jsx("p", {
    className: "homolcsat-v3-appreciation-csat__text gray"
  }, void 0, i18n.gettext('Vamos a usar la dirección e-mail que ofreciste cuando te registraste.'))), /*#__PURE__*/components_CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/components_CSATthankYou_jsx("p", {
    className: "homolcsat-v3-appreciation-csat__email normal"
  }, void 0, email)), /*#__PURE__*/components_CSATthankYou_jsx("div", {}, void 0, /*#__PURE__*/components_CSATthankYou_jsx("p", {
    className: "homolcsat-v3-appreciation-csat__text normal"
  }, void 0, i18n.gettext('Al hacer clic en el botón "Sí, acepto", autorizo que Mercado Pago me contacte por e-mail para entender mejor mi evaluación.'))), /*#__PURE__*/components_CSATthankYou_jsx("div", {
    className: "homolcsat-v3-appreciation-csat__wrapper"
  }, void 0, /*#__PURE__*/components_CSATthankYou_jsx((button_default()), {
    onClick: onAcceptEmail
  }, void 0, i18n.gettext('Sí, acepto')), /*#__PURE__*/components_CSATthankYou_jsx("div", {
    className: "homolcsat-v3-appreciation-csat__buttonDiv"
  }, void 0, /*#__PURE__*/components_CSATthankYou_jsx((button_default()), {
    hierarchy: "quiet",
    onClick: nextStep,
    "data-testid": "button-end"
  }, void 0, i18n.gettext('Terminar'))))));
};
;// CONCATENATED MODULE: ./src/HomologCSAT/components/HomologHeader/index.js
var _img, HomologHeader_Pill;
var HomologHeader_REACT_ELEMENT_TYPE;
function HomologHeader_jsx(e, r, E, l) { HomologHeader_REACT_ELEMENT_TYPE || (HomologHeader_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: HomologHeader_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
/* eslint-disable nordic/no-img-tags */


const HomologHeader = _ref => {
  let {
    scoreHomologation,
    header,
    pendingCounter,
    i18n
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, scoreHomologation === 100 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, _img || (_img = /*#__PURE__*/HomologHeader_jsx("img", {
    src: "https://http2.mlstatic.com/frontend-assets/dx-devsite/imagesfeedback/score_100.png",
    alt: "Perfect homologation score"
  })), /*#__PURE__*/HomologHeader_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/HomologHeader_jsx("p", {
    className: "homolcsat-v3-homolog__title weakBlack"
  }, void 0, header.congratulations))), scoreHomologation !== 100 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/HomologHeader_jsx("div", {
    className: "homolcsat-v3-homolog__wrapper"
  }, void 0, HomologHeader_Pill || (HomologHeader_Pill = /*#__PURE__*/HomologHeader_jsx(badge_namespaceObject.Pill, {
    contentType: "icon",
    size: "large",
    color: "orange"
  })), /*#__PURE__*/HomologHeader_jsx("h1", {
    className: "homolcsat-v3-homolog__title warning orange"
  }, void 0, i18n.gettext('Tu homologación finalizó con {0} mejoras pendientes', pendingCounter))), /*#__PURE__*/HomologHeader_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/HomologHeader_jsx("p", {
    className: "homolcsat-v3-homolog__subtitle gray"
  }, void 0, header.improve))), /*#__PURE__*/HomologHeader_jsx("div", {}, void 0, /*#__PURE__*/HomologHeader_jsx("h2", {
    className: "homolcsat-v3-homolog__title black"
  }, void 0, header.avaliation)), /*#__PURE__*/HomologHeader_jsx("div", {}, void 0, /*#__PURE__*/HomologHeader_jsx("p", {
    className: "homolcsat-v3-homolog__subtitle gray"
  }, void 0, header.solicitation)));
};
;// CONCATENATED MODULE: ./src/HomologCSAT/texts.js
/* eslint-disable max-len */
// Nos campos com label e name, o name é enviado para o banco de dados, e armazena em uma unica lingua as justificativas do feedback
// O label é usado para traduzir com o i18n.

function HomologCSAT_texts_getTexts(i18n) {
  return [{
    title: i18n.gettext('¡Atención!'),
    subtitle: i18n.gettext('Generamos los resultados de tu aplicación e identificamos pendientes. Puedes revisarlo o continuar con la finalización.'),
    button1: i18n.gettext('Revisar'),
    button2: i18n.gettext('Finalizar')
  }, {
    header: {
      congratulations: i18n.gettext('¡Felicitaciones! Tu aplicación finalizó con éxito'),
      pending: i18n.gettext('Tu homologación finalizó con {0} mejoras pendientes'),
      improve: i18n.gettext('Identifica puntos de mejora en tu integración y déjala de acuerdo con los estándares de Mercado Pago.'),
      avaliation: i18n.gettext('Evalúa tu experiencia'),
      solicitation: i18n.gettext('Ayúdanos a mejorar la experiencia de nuestros productos y servicios respondiendo a la siguiente pregunta:')
    },
    question: {
      name: '¿Qué tan satisfecho(a) estás con la herramienta de calidad de la integración?',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con la herramienta de calidad de la integración?')
    },
    checkboxes: {
      veryDissatisfied: [{
        name: 'La información sobre cómo hacer la prueba de calidad de la integración no es clara.',
        label: i18n.gettext('La información sobre cómo hacer la prueba de calidad de la integración no es clara.')
      }, {
        name: 'La prueba de calidad de la integración no me ayudó a entender mejor las integraciones.',
        label: i18n.gettext('La prueba de calidad de la integración no me ayudó a entender mejor las integraciones.')
      }, {
        name: 'Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.',
        label: i18n.gettext('Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.')
      }, {
        name: 'No entendí el objetivo de hacer la prueba de calidad de mi integración.',
        label: i18n.gettext('No entendí el objetivo de hacer la prueba de calidad de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      dissatisfied: [{
        name: 'La información sobre cómo hacer la prueba de calidad de la integración no es clara.',
        label: i18n.gettext('La información sobre cómo hacer la prueba de calidad de la integración no es clara.')
      }, {
        name: 'La prueba de calidad de la integración no me ayudó a entender mejor las integraciones.',
        label: i18n.gettext('La prueba de calidad de la integración no me ayudó a entender mejor las integraciones.')
      }, {
        name: 'Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.',
        label: i18n.gettext('Me pareció difícil entender cómo hacer los cambios sugeridos por la herramienta.')
      }, {
        name: 'No entendí el objetivo de hacer la prueba de calidad de mi integración.',
        label: i18n.gettext('No entendí el objetivo de hacer la prueba de calidad de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      neutral: [],
      satisfied: [{
        name: 'La información sobre la prueba de calidad de la integración es clara.',
        label: i18n.gettext('La información sobre la prueba de calidad de la integración es clara.')
      }, {
        name: 'La prueba de calidad de la integración me ayudó a integrar  mejor mi aplicación.',
        label: i18n.gettext('La prueba de calidad de la integración me ayudó a integrar  mejor mi aplicación.')
      }, {
        name: 'Me pareció fácil hacer la prueba de mi integración.',
        label: i18n.gettext('Me pareció fácil hacer la prueba de mi integración.')
      }, {
        name: 'Entendí el objetivo de hacer la prueba de calidad de mi integración.',
        label: i18n.gettext('Entendí el objetivo de hacer la prueba de calidad de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }],
      verySatisfied: [{
        name: 'La información sobre la prueba de calidad de la integración es clara.',
        label: i18n.gettext('La información sobre la prueba de calidad de la integración es clara.')
      }, {
        name: 'La prueba de calidad de la integración me ayudó a integrar  mejor mi aplicación.',
        label: i18n.gettext('La prueba de calidad de la integración me ayudó a integrar  mejor mi aplicación.')
      }, {
        name: 'Me pareció fácil hacer la prueba de mi integración.',
        label: i18n.gettext('Me pareció fácil hacer la prueba de mi integración.')
      }, {
        name: 'Entendí el objetivo de hacer la prueba de calidad de mi integración.',
        label: i18n.gettext('Entendí el objetivo de hacer la prueba de calidad de mi integración.')
      }, {
        name: 'Otros. ¿Cuáles?',
        label: i18n.gettext('Otros. ¿Cuáles?')
      }]
    }
  }];
}
;// CONCATENATED MODULE: ./src/HomologCSAT/index.js
var HomologCSAT_REACT_ELEMENT_TYPE;
function HomologCSAT_jsx(e, r, E, l) { HomologCSAT_REACT_ELEMENT_TYPE || (HomologCSAT_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: HomologCSAT_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function HomologCSAT_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function HomologCSAT_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? HomologCSAT_ownKeys(Object(t), !0).forEach(function (r) { HomologCSAT_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HomologCSAT_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HomologCSAT_defineProperty(e, r, t) { return (r = HomologCSAT_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function HomologCSAT_toPropertyKey(t) { var i = HomologCSAT_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function HomologCSAT_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










const HomologCSAT = _ref => {
  let {
    i18n = i18nNOOP,
    texts,
    onSend,
    onAcceptEmail,
    email,
    scoreHomologation = 50,
    evaluateAgainBTN,
    pendingCounter
  } = _ref;
  const STEPS = texts || HomologCSAT_texts_getTexts(i18n);
  const [step, setStep] = (0,external_react_namespaceObject.useState)(scoreHomologation === 100 ? 1 : 0);
  const [satisfaction, setSatisfaction] = (0,external_react_namespaceObject.useState)(null);
  const [details, setDetails] = (0,external_react_namespaceObject.useState)(STEPS[step]);

  /* istanbul ignore next */
  const nextStep = () => {
    setStep(step + 1);
  };
  const send = data => {
    const result = HomologCSAT_objectSpread(HomologCSAT_objectSpread({}, data), {}, {
      step
    });
    nextStep();
    if (onSend) {
      setSatisfaction(null);
      onSend(result);
    }
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    setDetails(STEPS[step]);
  }, [step]);

  /* istanbul ignore next */
  function acceptFunctions() {
    if (onAcceptEmail) {
      onAcceptEmail();
    }
    nextStep();
  }
  return /*#__PURE__*/HomologCSAT_jsx(CSATform_CSATform, {
    step: step,
    onSend: send
  }, void 0, step === 0 && /*#__PURE__*/HomologCSAT_jsx(CSATStart, {
    title: details.title,
    subtitle: details.subtitle,
    button1: details.button1,
    button2: details.button2,
    evaluateAgainBTN: evaluateAgainBTN,
    nextStep: nextStep,
    i18n: i18n
  }), step === 1 && details.header && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/HomologCSAT_jsx(HomologHeader, {
    i18n: i18n,
    step: step,
    scoreHomologation: scoreHomologation,
    header: details.header,
    pendingCounter: pendingCounter
  }), /*#__PURE__*/HomologCSAT_jsx(components_AskSatisfaction_AskSatisfaction, {
    onChange: setSatisfaction,
    value: satisfaction,
    question: details === null || details === void 0 ? void 0 : details.question,
    i18n: i18n,
    scoreHomologation: scoreHomologation
  }), Boolean(satisfaction) && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/HomologCSAT_jsx(components_AskSatisfactionReason_AskSatisfactionReason, {
    step: step,
    satisfaction: satisfaction,
    STEPS: STEPS,
    i18n: i18n
  }), /*#__PURE__*/HomologCSAT_jsx((button_default()), {
    type: "submit"
  }, void 0, i18n.gettext('Enviar')))), step >= 2 && /*#__PURE__*/HomologCSAT_jsx(components_CSATthankYou_ThankYou, {
    i18n: i18n,
    step: step,
    email: email,
    onAcceptEmail: acceptFunctions,
    nextStep: nextStep
  }));
};
;// CONCATENATED MODULE: ./src/NPS/components/NPSform/index.js
var NPSform_REACT_ELEMENT_TYPE;
function NPSform_jsx(e, r, E, l) { NPSform_REACT_ELEMENT_TYPE || (NPSform_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: NPSform_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const NPSform = _ref => {
  let {
    children,
    onSend
  } = _ref;
  const submit = e => {
    e.preventDefault();
    const form = e.target;
    const data = external_form_serialize_default()(form, {
      hash: true
    });

    /**
     * We use the parser(stringfy()) techinique here
     * to remove all key: undefined|null pairs from JSON.
     * The hard coded undefined ones are here by "doc" reasons.
     * The other ones may occur on additional_info
     */
    const result = JSON.parse(JSON.stringify({
      category: 'NPS',
      session: undefined,
      site_id: undefined,
      key: data.key,
      value: data.value,
      user_id: undefined,
      validator: 'NPS',
      additional_info: {
        reasons: data.reasons,
        language: undefined,
        comment: data.comment,
        url: getCurrentUrl()
      }
    }));
    if (onSend) {
      onSend(result);
    }
  };
  return /*#__PURE__*/NPSform_jsx("div", {
    className: "feedback-v3"
  }, void 0, /*#__PURE__*/NPSform_jsx("div", {
    className: "feedback-v3__div--center"
  }, void 0, /*#__PURE__*/NPSform_jsx("form", {
    onSubmit: submit
  }, void 0, children)));
};
;// CONCATENATED MODULE: ./src/NPS/components/NPStitle/index.js
var NPStitle_REACT_ELEMENT_TYPE;
function NPStitle_jsx(e, r, E, l) { NPStitle_REACT_ELEMENT_TYPE || (NPStitle_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: NPStitle_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const NPStitle = _ref => {
  let {
    i18n,
    title,
    subtitle,
    onClick
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/NPStitle_jsx("h2", {
    className: "nps-v3__title"
  }, void 0, title), /*#__PURE__*/NPStitle_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/NPStitle_jsx("p", {
    className: "nps-v3__title-text"
  }, void 0, subtitle)), /*#__PURE__*/NPStitle_jsx((button_default()), {
    "data-testid": "button-start",
    onClick: onClick,
    size: "medium"
  }, void 0, i18n.gettext('Empezar')));
};
;// CONCATENATED MODULE: ./src/NPS/components/StepTitle/index.js
var components_StepTitle_REACT_ELEMENT_TYPE;
function components_StepTitle_jsx(e, r, E, l) { components_StepTitle_REACT_ELEMENT_TYPE || (components_StepTitle_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_StepTitle_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const StepTitle_StepTitle = _ref => {
  let {
    i18n,
    title,
    subtitle
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/components_StepTitle_jsx("h2", {
    className: "feedback-v3__title"
  }, void 0, i18n.gettext(title)), /*#__PURE__*/components_StepTitle_jsx("p", {
    className: "feedback-v3__title-text"
  }, void 0, i18n.gettext(subtitle)));
};
;// CONCATENATED MODULE: ./src/NPS/components/NPSscore/index.js
var _label, _label2, _label3, _label4, _label5, _label6, _label7, _label8, _label9, _label10;
var NPSscore_REACT_ELEMENT_TYPE;
function NPSscore_jsx(e, r, E, l) { NPSscore_REACT_ELEMENT_TYPE || (NPSscore_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: NPSscore_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable nordic/i18n-jsx-no-literals */

const NPSscore = _ref => {
  let {
    i18n,
    question,
    setChecked
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, Boolean(question) && /*#__PURE__*/NPSscore_jsx("h3", {
    className: "nps-v3__question"
  }, void 0, i18n.gettext(question.label)), /*#__PURE__*/NPSscore_jsx("input", {
    type: "hidden",
    name: "key",
    defaultValue: question === null || question === void 0 ? void 0 : question.name
  }), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__nps"
  }, void 0, /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "1",
    value: "1",
    name: "value"
  }), _label || (_label = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "1"
  }, void 0, "1"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "2",
    value: "2",
    name: "value"
  }), _label2 || (_label2 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "2"
  }, void 0, "2"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "3",
    value: "3",
    name: "value"
  }), _label3 || (_label3 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "3"
  }, void 0, "3"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "4",
    value: "4",
    name: "value"
  }), _label4 || (_label4 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "4"
  }, void 0, "4"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "5",
    value: "5",
    name: "value"
  }), _label5 || (_label5 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "5"
  }, void 0, "5"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "6",
    value: "6",
    name: "value"
  }), _label6 || (_label6 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "6"
  }, void 0, "6"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "7",
    value: "7",
    name: "value"
  }), _label7 || (_label7 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "7"
  }, void 0, "7"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "8",
    value: "8",
    name: "value"
  }), _label8 || (_label8 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "8"
  }, void 0, "8"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "9",
    value: "9",
    name: "value"
  }), _label9 || (_label9 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "9"
  }, void 0, "9"))), /*#__PURE__*/NPSscore_jsx("div", {
    className: "nps-v3__radio"
  }, void 0, /*#__PURE__*/NPSscore_jsx("input", {
    onClick: () => setChecked(true),
    type: "radio",
    id: "10",
    value: "10",
    name: "value"
  }), _label10 || (_label10 = /*#__PURE__*/NPSscore_jsx("label", {
    htmlFor: "10"
  }, void 0, "10")))));
};
;// CONCATENATED MODULE: ./src/NPS/components/NPSthankYou/index.js
var NPSthankYou_FeedbackPositive;
var NPSthankYou_REACT_ELEMENT_TYPE;
function NPSthankYou_jsx(e, r, E, l) { NPSthankYou_REACT_ELEMENT_TYPE || (NPSthankYou_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: NPSthankYou_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }


const NPSthankYou = _ref => {
  let {
    i18n
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/NPSthankYou_jsx("div", {
    className: "feedback-v3-appreciation-nps__wrapper"
  }, void 0, NPSthankYou_FeedbackPositive || (NPSthankYou_FeedbackPositive = /*#__PURE__*/NPSthankYou_jsx((FeedbackPositive24_default()), {
    color: "#00A650"
  })), /*#__PURE__*/NPSthankYou_jsx("h1", {
    className: "feedback-v3-appreciation-nps__title"
  }, void 0, i18n.gettext('Agradecemos tu opinión'))), /*#__PURE__*/NPSthankYou_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/NPSthankYou_jsx("p", {
    className: "feedback-v3-appreciation-nps__text"
  }, void 0, i18n.gettext('¡Tu feedback nos ayuda a mejorar lo que ofrecemos!'))));
};
;// CONCATENATED MODULE: ./src/NPS/texts.js
/* eslint-disable max-len */
// Nos campos com label e name, o name é enviado para o banco de dados, e armazena em uma unica lingua as justificativas do feedback
// O label é usado para traduzir com o i18n.

function NPS_texts_getTexts(i18n) {
  return [{
    title: i18n.gettext('¿Tienes 2 minutos para darnos tu feedback?'),
    subtitle: i18n.gettext('Nos encantaría saber más de tu experiencia dentro de Mercado Pago Developers')
  }, {
    title: i18n.gettext('Evalúa tu experiencia'),
    subtitle: i18n.gettext('Para que nos ayudes a ofrecer una mejor experiencia, nos gustaría pedirte que respondas esta breve encuesta de unos segundos.'),
    question: {
      name: '¿Qué tan satisfecho(a) estás con la experiencia de tus integraciones?',
      label: i18n.gettext('¿Qué tan satisfecho(a) estás con la experiencia de tus integraciones?')
    }
  }, {
    title: i18n.gettext('Evalúa tu experiencia'),
    subtitle: i18n.gettext('Ayúdanos a mejorar la experiencia de nuestros productos y servicios respondiendo a la siguiente pregunta:')
  }];
}
;// CONCATENATED MODULE: ./src/NPS/index.js
var NPS_REACT_ELEMENT_TYPE;
function NPS_jsx(e, r, E, l) { NPS_REACT_ELEMENT_TYPE || (NPS_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: NPS_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function NPS_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NPS_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NPS_ownKeys(Object(t), !0).forEach(function (r) { NPS_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NPS_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NPS_defineProperty(e, r, t) { return (r = NPS_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function NPS_toPropertyKey(t) { var i = NPS_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function NPS_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









const NPS = _ref => {
  let {
    i18n = i18nNOOP,
    onSend,
    texts
  } = _ref;
  const STEPS = texts || NPS_texts_getTexts(i18n);
  const [step, setStep] = (0,external_react_namespaceObject.useState)(0);
  const [checked, setChecked] = (0,external_react_namespaceObject.useState)(false);
  const [details, setDetails] = (0,external_react_namespaceObject.useState)(STEPS[step]);
  const send = data => {
    const result = NPS_objectSpread(NPS_objectSpread({}, data), {}, {
      step
    });
    setStep(step + 1);
    if (onSend) {
      onSend(result);
    }
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    setDetails(STEPS[step]);
  }, [step]);
  return /*#__PURE__*/NPS_jsx(NPSform, {
    onSend: send
  }, void 0, step === 0 && /*#__PURE__*/NPS_jsx(NPStitle, {
    title: details.title,
    subtitle: details.subtitle,
    onClick: () => setStep(step + 1),
    i18n: i18n
  }), step === 1 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/NPS_jsx(StepTitle_StepTitle, {
    title: details.title,
    subtitle: details.subtitle,
    i18n: i18n
  }), /*#__PURE__*/NPS_jsx(NPSscore, {
    i18n: i18n,
    setChecked: setChecked,
    question: details.question
  }), /*#__PURE__*/NPS_jsx((button_default()), {
    disabled: !checked,
    type: "submit"
  }, void 0, i18n.gettext('Enviar'))), step === 2 && /*#__PURE__*/NPS_jsx(NPSthankYou, {
    i18n: i18n
  }));
};
;// CONCATENATED MODULE: external "striptags"
const external_striptags_namespaceObject = require("striptags");
var external_striptags_default = /*#__PURE__*/__webpack_require__.n(external_striptags_namespaceObject);
;// CONCATENATED MODULE: ./src/utils/patternsSqlKeywords.js
const patterns = [new RegExp('(%27)|(\')|(--)|(%23)|(#)|(;)', 'gi'), new RegExp('((%3D)|(=))[^\\n]*((%27)|(\')|(--)|(%3B)|(;))', 'gi'), new RegExp('w*((%27)|(\'))((%6F)|o|(%4F))((%72)|r|(%52))', 'gi'), new RegExp('((%27)|(\'))union', 'gi'),
// sql keywords
new RegExp('\\bselect\\b', 'gi'), new RegExp('\\bdrop\\b', 'gi'), new RegExp('\\bfrom\\b', 'gi'), new RegExp('\\bwhere\\b', 'gi'), new RegExp('\\binsert\\b', 'gi'), new RegExp('\\bupdate\\b', 'gi'), new RegExp('\\bdelete\\b', 'gi'), new RegExp('\\btable\\b', 'gi'), new RegExp('\\binto\\b', 'gi'), new RegExp('\\bvalues\\b', 'gi'), new RegExp('\\bcreate\\b', 'gi'), new RegExp('\\balter\\b', 'gi'), new RegExp('\\btruncate\\b', 'gi'), new RegExp('\\bjoin\\b', 'gi'), new RegExp('\\*', 'g'), new RegExp('=', 'g')];
;// CONCATENATED MODULE: ./src/utils/string-utils.js


function countWords(str) {
  let minWordSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (!str || typeof str !== 'string') {
    return 0;
  }
  return str.split(' ').filter(word => word.length >= minWordSize).length;
}
function strNormalize(str) {
  // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
  return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function removeSQLInjection(comment) {
  let sanitizedComment = comment;
  patterns.forEach(pattern => {
    sanitizedComment = sanitizedComment.replace(pattern, '');
  });
  return sanitizedComment;
}
function removeTags(innerHTML) {
  const cleaned = external_striptags_default()(innerHTML);
  return cleaned;
}
function normalizeComment(comment) {
  if (!comment || typeof comment !== 'string') {
    return '';
  }
  let normalizedComment = comment;
  normalizedComment = strNormalize(normalizedComment);
  normalizedComment = removeSQLInjection(normalizedComment);
  normalizedComment = removeTags(normalizedComment);
  normalizedComment = normalizedComment.replace(/\s+/g, ' ').trim();
  return normalizedComment.toLowerCase();
}
;// CONCATENATED MODULE: ./src/BugReport/texts.js
/* eslint-disable max-len */
// Nos campos com label e name, o name é enviado para o banco de dados, e armazena em uma unica lingua as justificativas do feedback
// O label é usado para traduzir com o i18n.

function getBasicInfoDropdown(i18n) {
  return [['home_mp_developers', i18n.gettext('Home de Mercado Pago Developers'), 'Home de Mercado Pago Developers'], ['home_partnership', i18n.gettext('Home del Partners Program'), 'Home del Partners Program'], ['documentation', i18n.gettext('Documentaciones'), 'Documentaciones'], ['tutorial_video', i18n.gettext('Videos tutoriales'), 'Videos tutoriales'], ['demostration', i18n.gettext('Demostración'), 'Demostración'], ['api_and_sdks', i18n.gettext('API y SDKs'), 'API y SDKs'], ['credentials', i18n.gettext('Credenciales'), 'Credenciales'], ['testing_tools', i18n.gettext('Herramientas de prueba'), 'Herramientas de prueba'], ['notifications', i18n.gettext('Notificaciones'), 'Notificaciones'], ['integration_quality', i18n.gettext('Calidad de la integración'), 'Calidad de la integración'], ['certifications', i18n.gettext('Certificación'), 'Certificación']];
}
function getBasicInfoSegments(i18n) {
  return {
    home_partnership: [['agencies', i18n.gettext('Agencias'), 'Agencias'], ['platforms', i18n.gettext('Plataformas'), 'platforms'], ['developers', i18n.gettext('Developers'), 'Developers']],
    documentation: [['checkout_pro', i18n.gettext('Checkout Pro'), 'Checkout Pro'], ['checkout_bricks', i18n.gettext('Checkout Bricks'), 'Checkout Bricks'], ['checkout_api', i18n.gettext('Checkout Api'), 'Checkout Api'], ['subscriptions', i18n.gettext('Suscripciones'), 'Suscripciones'], ['payments_links', i18n.gettext('Link de pago'), 'Link de pago'], ['wallet_connect', i18n.gettext('Wallet Connect'), 'Wallect Connect'], ['qr_code', i18n.gettext('Código QR'), 'Código QR'], ['mp_point', i18n.gettext('Point Mercado Pago'), 'Point Mercado Pago']],
    demostration: [['checkout_pro', i18n.gettext('Checkout Pro'), 'Checkout Pro'], ['wallet_bricks', i18n.gettext('Wallet Bricks'), 'Wallet Bricks'], ['status_screen_brick', i18n.gettext('Status Screen Brick'), 'Status Screen Brick'], ['payment_brick', i18n.gettext('Payment Brick'), 'Payment Brick'], ['card_payment_brick', i18n.gettext('Card Payment Brick'), 'Card Payment Brick']],
    testing_tools: [['test_card', i18n.gettext('Tarjetas de prueba'), 'Tarjetas de prueba'], ['test_account', i18n.gettext('Cuenta de Prueba'), 'Cuenta de Prueba']],
    notifications: [['webhook', i18n.gettext('Webhooks'), 'Webhooks'], ['ipn', i18n.gettext('IPN'), 'IPN']],
    integration_quality: [['payments_online', i18n.gettext('Pagos Online'), 'Pagos Online'], ['payments_qr', i18n.gettext('Pagos con QR'), 'Pagos con QR']],
    certifications: [['checkout_pro', i18n.gettext('Checkout Pro'), 'Checkout Pro'], ['woo_commerce', i18n.gettext('WooCommerce'), 'WooCommerce'], ['adobe_ecommerce', i18n.gettext('Adobe Commerce'), 'Adobe Commerce']]
  };
}
function getTechInfo(i18n) {
  return {
    equipment_type: [[i18n.gettext('Mobile'), 'Mobile'], [i18n.gettext('Desktop'), 'Desktop'], [i18n.gettext('Tablet'), 'Tablet']],
    Desktop: [[i18n.gettext('Mac OS'), 'Mac OS'], [i18n.gettext('Windows'), 'Windows'], [i18n.gettext('Linux'), 'Linux']],
    Mobile: [[i18n.gettext('IOS'), 'IOS'], [i18n.gettext('Android'), 'Android']],
    Tablet: [[i18n.gettext('IOS'), 'IOS'], [i18n.gettext('Android'), 'Android']],
    browser: [[i18n.gettext('Chrome'), 'Chrome'], [i18n.gettext('Safari'), 'Safari'], [i18n.gettext('Edge'), 'Edge'], [i18n.gettext('Firefox'), 'Firefox'], [i18n.gettext('Opera'), 'Opera'], [i18n.gettext('Samsung Internet'), 'Samsung Internet'], [i18n.gettext('Outros'), 'Outros']]
  };
}
function getErrorOptions(i18n) {
  return [[i18n.gettext('Error de código'), 'Error de código'], [i18n.gettext('Error de diseño'), 'Error de diseño'], [i18n.gettext('Nueva sugerencia'), 'Nueva sugerencia'], [i18n.gettext('Problema en la documentación'), 'Problema en la documentación'], [i18n.gettext('Problema de hardware'), 'Problema de hardware'], [i18n.gettext('Otros'), 'Otros']];
}
function getErrorImpact(i18n) {
  return [[i18n.gettext('No puedo finalizar el proceso de integración'), 'No puedo finalizar el proceso de integración'], [i18n.gettext('No puedo hacer una o más etapas que afectan el funcionamiento de mi integración'), 'No puedo hacer una o más etapas que afectan el funcionamiento de mi integración'], [i18n.gettext('No puedo hacer una o más etapas, pero eso no afecta el funcionamiento de mi integración'), 'No puedo hacer una o más etapas, pero eso no afecta el funcionamiento de mi integración'], [i18n.gettext('No puedo probar la integración que hice'), 'No puedo probar la integración que hice'], [i18n.gettext('El error no perjudica el proceso de integración'), 'El error no perjudica el proceso de integración']];
}
;// CONCATENATED MODULE: ./src/BugReport/validator.js



const texts = getBasicInfoDropdown(i18nNOOP);
const segments = getBasicInfoSegments(i18nNOOP);
const techInfo = getTechInfo(i18nNOOP);
function validateSegmentExists(value) {
  try {
    return Boolean(texts === null || texts === void 0 ? void 0 : texts.find(item => item[0] === value));
  } catch (error) {
    console.error('Bug Report - Error validating the existence of a segment given a respective basicDropOne value: ', error);
    return false;
  }
}
function validateSystem(value) {
  try {
    return Boolean(techInfo[value]);
  } catch (error) {
    console.error('Bug Report - Error validating the existence of a system given a respective techDropOne value: ', error);
    return false;
  }
}
function isCommentValid(payload) {
  const {
    comment
  } = (payload === null || payload === void 0 ? void 0 : payload.additional_info) || {};
  if (!comment) {
    return false;
  }
  const normalizedComment = normalizeComment(comment);
  const result = countWords(normalizedComment) >= 3;
  return result;
}
function isValidURL(payload) {
  if (!payload.additional_info || !payload.additional_info.url) {
    return true;
  }
  const urlString = payload.additional_info.url;
  try {
    const url = new URL(urlString);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      console.log('Protocolo inválido:', url.protocol);
      return false;
    }
    return true;
  } catch (error) {
    console.error("Erro ao validar a URL: ".concat(urlString), error);
    return false;
  }
}
function validateBugReport(data) {
  if (data && data.value && data.additional_info.equipment) {
    return validateSegmentExists(data.value) && validateSystem(data.additional_info.equipment) && isCommentValid(data) && isValidURL(data);
  }
  return false;
}
;// CONCATENATED MODULE: ./src/BugReport/components/BugReportForm/index.js
var BugReportForm_REACT_ELEMENT_TYPE;
function BugReportForm_jsx(e, r, E, l) { BugReportForm_REACT_ELEMENT_TYPE || (BugReportForm_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: BugReportForm_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const BugReportForm = _ref => {
  let {
    children,
    onSend
  } = _ref;
  const submit = e => {
    e.preventDefault();
    const form = e.target;
    const data = external_form_serialize_default()(form, {
      hash: true
    });
    if (data.comment) {
      data.comment = normalizeComment(data.comment);
    }
    if (data.url && !isValidURL({
      url: data.url
    })) {
      return;
    }

    /**
     * We use the parser(stringfy()) techinique here
     * to remove all key: undefined|null pairs from JSON.
     * The hard coded undefined ones are here by "doc" reasons.
     * The other ones may occur on additional_info
     */
    const result = JSON.parse(JSON.stringify({
      category: 'BUG_REPORT',
      site_id: undefined,
      user_id: undefined,
      key: data.key,
      value: data.basicDropOne,
      segment: data.basicDropTwo,
      additional_info: {
        url: data.url,
        equipment: data.techDropOne,
        system: data.techDropTwo,
        browser: data.techDropThree,
        error_type: data.errorDropOne,
        comment: data.comment,
        severity: data.errorDropTwo,
        name: data.name,
        // honeyPot
        email: data.email // honeyPot
      },
      validator: 'BugReport'
    }));
    if (onSend) {
      onSend(result);
    }
  };
  return /*#__PURE__*/BugReportForm_jsx("form", {
    onSubmit: submit,
    noValidate: true
  }, void 0, children);
};
;// CONCATENATED MODULE: ./src/BugReport/components/BugReportBody/index.js
var BugReportBody_REACT_ELEMENT_TYPE;
function BugReportBody_jsx(e, r, E, l) { BugReportBody_REACT_ELEMENT_TYPE || (BugReportBody_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: BugReportBody_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const BugReportBody = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/BugReportBody_jsx("div", {
    className: "bug-report"
  }, void 0, /*#__PURE__*/BugReportBody_jsx("div", {
    className: "bug-report__div--center"
  }, void 0, children));
};
;// CONCATENATED MODULE: ./src/BugReport/components/Title/index.js
var Title_REACT_ELEMENT_TYPE;
function Title_jsx(e, r, E, l) { Title_REACT_ELEMENT_TYPE || (Title_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: Title_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

const Title = _ref => {
  let {
    i18n,
    lang,
    step
  } = _ref;
  return /*#__PURE__*/Title_jsx("div", {}, void 0, /*#__PURE__*/Title_jsx("h1", {
    className: "bug-report__step-count"
  }, void 0, i18n.gettext('Etapa {0} de 2', String(step))), /*#__PURE__*/Title_jsx("p", {
    className: "bug-report__title"
  }, void 0, i18n.gettext('Reporta errores en Mercado Pago Developers')), /*#__PURE__*/Title_jsx("p", {
    className: "bug-report__title-text"
  }, void 0, i18n.gettext('Reporta errores que encontraste en nuestro sitio y ayúdanos a mejorar nuestra experiencia. Si quieres ayuda con problemas en tu cuenta o en tu integración, '), /*#__PURE__*/Title_jsx("a", {
    href: "/developers/".concat(lang, "/support/center")
  }, void 0, i18n.gettext('ingresa a nuestro Soporte')), "."));
};
;// CONCATENATED MODULE: ./src/BugReport/components/BasicInformation/index.js
var _input, BasicInformation_div;
var BasicInformation_REACT_ELEMENT_TYPE;
function BasicInformation_jsx(e, r, E, l) { BasicInformation_REACT_ELEMENT_TYPE || (BasicInformation_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: BasicInformation_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const BasicInformation = _ref => {
  let {
    i18n,
    segmentsInfo,
    dropOneValue,
    setDropOneValue,
    dropTwoValue,
    setDropTwoValue
  } = _ref;
  const info = getBasicInfoDropdown(i18n);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/BasicInformation_jsx("h1", {
    className: "bug-report-basic__title"
  }, void 0, i18n.gettext('Información básica')), /*#__PURE__*/BasicInformation_jsx("div", {
    className: "bug-report-basic__infoDiv ".concat(segmentsInfo[dropOneValue] ? 'bigger' : 'smaller')
  }, void 0, /*#__PURE__*/BasicInformation_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "basicDropOne",
    id: "basicDropOne",
    menuMaxHeight: 250,
    value: dropOneValue,
    label: i18n.gettext('Selecciona en qué parte del sitio encontraste el error:'),
    onChange: event => {
      setDropOneValue(event.target.value);
      setDropTwoValue(null);
    }
  }, void 0, info.map(ele => /*#__PURE__*/BasicInformation_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[1],
    value: ele[0]
  }, ele[0]))), /*#__PURE__*/BasicInformation_jsx("input", {
    type: "hidden",
    name: "basicDropOne",
    value: dropOneValue
  }), _input || (_input = /*#__PURE__*/BasicInformation_jsx("input", {
    type: "hidden",
    name: "key",
    value: "Selecciona en qu\xE9 parte del sitio encontraste el error:"
  })), segmentsInfo[dropOneValue] && /*#__PURE__*/BasicInformation_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "basicDropTwo",
    menuMaxHeight: 250,
    value: dropTwoValue,
    label: i18n.gettext('Especifica en qué segmento o producto aparece el error:'),
    onChange: event => setDropTwoValue(event.target.value)
  }, void 0, segmentsInfo[dropOneValue].map(ele => /*#__PURE__*/BasicInformation_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[1],
    value: ele[0]
  }, ele[0]))), /*#__PURE__*/BasicInformation_jsx("input", {
    type: "hidden",
    name: "basicDropTwo",
    value: dropTwoValue
  }), /*#__PURE__*/BasicInformation_jsx(textfield_namespaceObject.TextField, {
    maxLength: "100",
    id: "basicInput",
    countdown: true,
    name: "url",
    label: i18n.gettext('Ingresa la URL en la que se encuentra el error (Opcional):')
  }), BasicInformation_div || (BasicInformation_div = /*#__PURE__*/BasicInformation_jsx("div", {
    className: "fildsNoH0N3Y-container"
  }, void 0, /*#__PURE__*/BasicInformation_jsx("label", {
    className: "fildsNoH0N3Y",
    htmlFor: "email"
  }, void 0, /*#__PURE__*/BasicInformation_jsx("input", {
    className: "fildsNoH0N3Y",
    autoComplete: "off",
    type: "email",
    id: "email",
    name: "email"
  }))))));
};
;// CONCATENATED MODULE: ./src/BugReport/components/TechInformation/index.js
var TechInformation_REACT_ELEMENT_TYPE;
function TechInformation_jsx(e, r, E, l) { TechInformation_REACT_ELEMENT_TYPE || (TechInformation_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: TechInformation_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const TechInformation = _ref => {
  var _info$equipment_type, _info$info$equipment_, _info$equipment_type2, _info$browser;
  let {
    i18n,
    dropOneValue,
    setDropOneValue,
    dropTwoValue,
    setDropTwoValue,
    dropThreeValue,
    setDropThreeValue,
    deviceType
  } = _ref;
  const info = getTechInfo(i18n);
  function getBrowser() {
    if (typeof window !== 'undefined') {
      var _window;
      const navigator = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search('Edg')) > -1) {
        return 'Edge';
      }
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search(/Samsung/i)) > -1) {
        return 'Samsung Internet';
      }
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search('Chrome')) > -1) {
        return 'Chrome';
      }
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search('Safari')) > -1) {
        return 'Safari';
      }
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search('Opera')) > -1) {
        return 'Opera';
      }
      if ((navigator === null || navigator === void 0 ? void 0 : navigator.search('Firefox')) > -1) {
        return 'Firefox';
      }
      return 'Outros';
    }
    return null;
  }
  function getSystem() {
    if (deviceType === 'desktop') {
      return 'Desktop';
    }
    if (deviceType === 'mobile') {
      return 'Mobile';
    }
    if (deviceType === 'tablet') {
      return 'Tablet';
    }
    return null;
  }
  (0,external_react_namespaceObject.useEffect)(() => {
    setDropThreeValue(getBrowser());
    setDropOneValue(getSystem());
  }, []);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/TechInformation_jsx("h1", {
    className: "bug-report-basic__title"
  }, void 0, i18n.gettext('Información técnica')), /*#__PURE__*/TechInformation_jsx("div", {
    className: "bug-report-basic__infoDiv ".concat(dropOneValue ? 'bigger' : 'smaller')
  }, void 0, /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "techDropOne",
    id: "techDropOne",
    menuMaxHeight: 250,
    value: dropOneValue,
    label: i18n.gettext('Ingresa el tipo de equipo que estás usando:'),
    onChange: event => {
      setDropOneValue(event.target.value);
      setDropTwoValue(null);
    }
  }, void 0, (_info$equipment_type = info.equipment_type) === null || _info$equipment_type === void 0 ? void 0 : _info$equipment_type.map(ele => /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[0],
    value: ele[1]
  }, ele[1]))), /*#__PURE__*/TechInformation_jsx("input", {
    type: "hidden",
    name: "techDropOne",
    value: dropOneValue
  }), dropOneValue && /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "techDropTwo",
    id: "techDropTwo",
    menuMaxHeight: 250,
    value: dropTwoValue,
    label: i18n.gettext('Selecciona el sistema operativo que estás usando (Opcional):'),
    onChange: event => setDropTwoValue(event.target.value)
  }, void 0, dropOneValue && ((_info$info$equipment_ = info[(_info$equipment_type2 = info.equipment_type) === null || _info$equipment_type2 === void 0 ? void 0 : _info$equipment_type2.find(ele => ele[1] === dropOneValue)[1]]) === null || _info$info$equipment_ === void 0 ? void 0 : _info$info$equipment_.map(ele => /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[0],
    value: ele[1]
  }, ele[1])))), /*#__PURE__*/TechInformation_jsx("input", {
    type: "hidden",
    name: "techDropTwo",
    value: dropTwoValue
  }), /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "techDropThree",
    id: "techDropThree",
    menuMaxHeight: 250,
    value: dropThreeValue,
    label: i18n.gettext('Elige el navegador que estás usando:'),
    onChange: event => setDropThreeValue(event.target.value)
  }, void 0, (_info$browser = info.browser) === null || _info$browser === void 0 ? void 0 : _info$browser.map(ele => /*#__PURE__*/TechInformation_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[0],
    value: ele[1]
  }, ele[1]))), /*#__PURE__*/TechInformation_jsx("input", {
    type: "hidden",
    name: "techDropThree",
    value: dropThreeValue
  })));
};
;// CONCATENATED MODULE: ./src/BugReport/components/ErrorDetails/index.js
var ErrorDetails_div;
var ErrorDetails_REACT_ELEMENT_TYPE;
function ErrorDetails_jsx(e, r, E, l) { ErrorDetails_REACT_ELEMENT_TYPE || (ErrorDetails_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ErrorDetails_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }




const ErrorDetails = _ref => {
  let {
    i18n,
    dropOneValue,
    setDropOneValue,
    dropTwoValue,
    setDropTwoValue,
    textValue,
    setTextValue
  } = _ref;
  const errorOptions = getErrorOptions(i18n);
  const errorImpact = getErrorImpact(i18n);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/ErrorDetails_jsx("h1", {
    className: "bug-report-error__title"
  }, void 0, i18n.gettext('Detalles del error')), /*#__PURE__*/ErrorDetails_jsx("div", {
    className: "bug-report-error__infoDiv"
  }, void 0, /*#__PURE__*/ErrorDetails_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "errorDropOne",
    id: "errorDropOne",
    menuMaxHeight: 250,
    value: dropOneValue,
    label: i18n.gettext('Elige la categoría que mejor describe el tipo de error que encontraste:'),
    onChange: event => {
      setDropOneValue(event.target.value);
    }
  }, void 0, errorOptions.map(ele => /*#__PURE__*/ErrorDetails_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[0],
    value: ele[1]
  }, ele[1]))), /*#__PURE__*/ErrorDetails_jsx("input", {
    type: "hidden",
    name: "errorDropOne",
    value: dropOneValue
  }), /*#__PURE__*/ErrorDetails_jsx("div", {
    className: "bug-report-error__padding"
  }, void 0, /*#__PURE__*/ErrorDetails_jsx((textfield_default()), {
    maxLength: "10000",
    rows: "4",
    multiline: true,
    name: "comment",
    id: "comment",
    value: textValue,
    onChange: event => {
      setTextValue(event.target.value);
    },
    label: i18n.gettext('Describe con el mayor nivel de detalle el error que quieres reportar:')
  })), /*#__PURE__*/ErrorDetails_jsx("div", {
    className: "bug-report-error__padding"
  }, void 0, /*#__PURE__*/ErrorDetails_jsx(dropdown_namespaceObject.DropdownForm, {
    srLabel: "",
    name: "errorDropTwo",
    id: "errorDropTwo",
    menuMaxHeight: 250,
    value: dropTwoValue,
    label: i18n.gettext('Indica cómo este error impacta en tu experiencia:'),
    onChange: event => setDropTwoValue(event.target.value)
  }, void 0, errorImpact.map(ele => /*#__PURE__*/ErrorDetails_jsx(dropdown_namespaceObject.DropdownItem, {
    title: ele[0],
    value: ele[1]
  }, ele[1])))), /*#__PURE__*/ErrorDetails_jsx("input", {
    type: "hidden",
    name: "errorDropTwo",
    value: dropTwoValue
  }), ErrorDetails_div || (ErrorDetails_div = /*#__PURE__*/ErrorDetails_jsx("div", {
    className: "fildsNoH0N3Y-container"
  }, void 0, /*#__PURE__*/ErrorDetails_jsx("label", {
    className: "fildsNoH0N3Y",
    htmlFor: "name"
  }, void 0, /*#__PURE__*/ErrorDetails_jsx("input", {
    className: "fildsNoH0N3Y",
    autoComplete: "off",
    type: "text",
    id: "name",
    name: "name"
  }))))));
};
;// CONCATENATED MODULE: ./src/BugReport/components/ThankYou/index.js
var ThankYou_FeedbackPositive;
var components_ThankYou_REACT_ELEMENT_TYPE;
function components_ThankYou_jsx(e, r, E, l) { components_ThankYou_REACT_ELEMENT_TYPE || (components_ThankYou_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: components_ThankYou_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }



const ThankYou_ThankYou = _ref => {
  let {
    i18n,
    onGoBeginning,
    onReportOther
  } = _ref;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/components_ThankYou_jsx("div", {
    className: "bug-report-appreciation__wrapper"
  }, void 0, ThankYou_FeedbackPositive || (ThankYou_FeedbackPositive = /*#__PURE__*/components_ThankYou_jsx((FeedbackPositive24_default()), {
    color: "#00A650"
  })), /*#__PURE__*/components_ThankYou_jsx("h1", {
    className: "bug-report-appreciation__title"
  }, void 0, i18n.gettext('¡Tu reporte se envió!'))), /*#__PURE__*/components_ThankYou_jsx("div", {
    style: {
      marginBottom: 20
    }
  }, void 0, /*#__PURE__*/components_ThankYou_jsx("p", {
    className: "bug-report-appreciation__text"
  }, void 0, i18n.gettext('Nuestro equipo técnico evaluará el reporte. Estamos constantemente mejorando Mercado Pago y tu opinión es muy importante para nosotros.'))), /*#__PURE__*/components_ThankYou_jsx("div", {
    className: "bug-report-appreciation__buttonWrapper"
  }, void 0, /*#__PURE__*/components_ThankYou_jsx("div", {}, void 0, /*#__PURE__*/components_ThankYou_jsx("a", {
    href: onReportOther
  }, void 0, /*#__PURE__*/components_ThankYou_jsx((button_default()), {
    id: "button-report-other"
  }, void 0, i18n.gettext('Reportar otro error')))), /*#__PURE__*/components_ThankYou_jsx("div", {
    className: "bug-report-appreciation__buttonDiv"
  }, void 0, /*#__PURE__*/components_ThankYou_jsx("a", {
    href: onGoBeginning
  }, void 0, /*#__PURE__*/components_ThankYou_jsx((button_default()), {
    hierarchy: "quiet",
    id: "button-go-beginning"
  }, void 0, i18n.gettext('Volver al Inicio'))))));
};
;// CONCATENATED MODULE: ./src/BugReport/index.js
var BugReport_REACT_ELEMENT_TYPE;
function BugReport_jsx(e, r, E, l) { BugReport_REACT_ELEMENT_TYPE || (BugReport_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: BugReport_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
function BugReport_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BugReport_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BugReport_ownKeys(Object(t), !0).forEach(function (r) { BugReport_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BugReport_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BugReport_defineProperty(e, r, t) { return (r = BugReport_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function BugReport_toPropertyKey(t) { var i = BugReport_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function BugReport_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











const BugReport = _ref => {
  let {
    i18n = i18nNOOP,
    onSend,
    lang = 'es',
    onGoBeginning,
    onReportOther,
    deviceType
  } = _ref;
  const segmentsInfo = getBasicInfoSegments(i18n);
  const [step, setStep] = (0,external_react_namespaceObject.useState)(1);
  const [disabled, setDisabled] = (0,external_react_namespaceObject.useState)(true);
  const [basicDropOneValue, setBasicDropOneValue] = (0,external_react_namespaceObject.useState)(null);
  const [basicDropTwoValue, setBasicDropTwoValue] = (0,external_react_namespaceObject.useState)(null);
  const [techDropOneValue, setTechDropOneValue] = (0,external_react_namespaceObject.useState)(null);
  const [techDropTwoValue, setTechDropTwoValue] = (0,external_react_namespaceObject.useState)(null);
  const [techDropThreeValue, setTechDropThreeValue] = (0,external_react_namespaceObject.useState)(null);
  const [detailDropOneValue, setDetailDropOneValue] = (0,external_react_namespaceObject.useState)(null);
  const [detailDropTwoValue, setDetailDropTwoValue] = (0,external_react_namespaceObject.useState)(null);
  const [detailTextValue, setDetailTextValue] = (0,external_react_namespaceObject.useState)(null);
  const [results, setResults] = (0,external_react_namespaceObject.useState)(null);
  const send = data => {
    var _payload$additional_i, _payload$additional_i2;
    const finalStep = 2;
    const payload = BugReport_objectSpread(BugReport_objectSpread(BugReport_objectSpread({}, results), data), {}, {
      additional_info: BugReport_objectSpread(BugReport_objectSpread({}, results === null || results === void 0 ? void 0 : results.additional_info), data.additional_info)
    });

    // if not trapped by any honeypot and is sending the last step:
    if (!(payload !== null && payload !== void 0 && (_payload$additional_i = payload.additional_info) !== null && _payload$additional_i !== void 0 && _payload$additional_i.email) && !(payload !== null && payload !== void 0 && (_payload$additional_i2 = payload.additional_info) !== null && _payload$additional_i2 !== void 0 && _payload$additional_i2.name) && onSend && step === finalStep) {
      onSend(payload);
    }
    setResults(payload);
    setStep(step + 1);
  };

  // Disables the form button unless all the required parameters are fulfilled
  (0,external_react_namespaceObject.useEffect)(() => {
    if (step === 1) {
      if (!basicDropOneValue || segmentsInfo[basicDropOneValue] && !basicDropTwoValue || !techDropOneValue || !techDropThreeValue) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    } else if (!detailDropOneValue || !detailDropTwoValue || !((detailTextValue === null || detailTextValue === void 0 ? void 0 : detailTextValue.length) > 5)) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [step, basicDropOneValue, basicDropTwoValue, techDropOneValue, techDropThreeValue, detailDropOneValue, detailDropTwoValue, detailTextValue]);
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/BugReport_jsx(BugReportForm, {
    onSend: send
  }, void 0, /*#__PURE__*/BugReport_jsx(BugReportBody, {}, void 0, step < 3 && /*#__PURE__*/BugReport_jsx(Title, {
    i18n: i18n,
    lang: lang,
    step: step
  }), step === 1 && /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/BugReport_jsx(BasicInformation, {
    i18n: i18n,
    segmentsInfo: segmentsInfo,
    dropOneValue: basicDropOneValue,
    setDropOneValue: setBasicDropOneValue,
    dropTwoValue: basicDropTwoValue,
    setDropTwoValue: setBasicDropTwoValue
  }), /*#__PURE__*/BugReport_jsx(TechInformation, {
    i18n: i18n,
    dropOneValue: techDropOneValue,
    setDropOneValue: setTechDropOneValue,
    dropTwoValue: techDropTwoValue,
    setDropTwoValue: setTechDropTwoValue,
    dropThreeValue: techDropThreeValue,
    setDropThreeValue: setTechDropThreeValue,
    deviceType: deviceType
  })), step === 2 && /*#__PURE__*/BugReport_jsx(ErrorDetails, {
    i18n: i18n,
    dropOneValue: detailDropOneValue,
    setDropOneValue: setDetailDropOneValue,
    textValue: detailTextValue,
    setTextValue: setDetailTextValue,
    dropTwoValue: detailDropTwoValue,
    setDropTwoValue: setDetailDropTwoValue
  }), step === 3 && /*#__PURE__*/BugReport_jsx(ThankYou_ThankYou, {
    i18n: i18n,
    onGoBeginning: onGoBeginning,
    onReportOther: onReportOther
  })), step < 3 && /*#__PURE__*/BugReport_jsx("div", {
    className: "bug-report__submit-button"
  }, void 0, /*#__PURE__*/BugReport_jsx(button_namespaceObject.Button, {
    type: "submit",
    disabled: disabled,
    "data-testid": "bug-report-submit"
  }, void 0, step < 2 ? i18n.gettext('Siguiente') : i18n.gettext('Enviar formulario')))));
};
;// CONCATENATED MODULE: external "frontend-i18n"
const external_frontend_i18n_namespaceObject = require("frontend-i18n");
;// CONCATENATED MODULE: external "@andes/icons/ThumbUpOutlined24"
const ThumbUpOutlined24_namespaceObject = require("@andes/icons/ThumbUpOutlined24");
var ThumbUpOutlined24_default = /*#__PURE__*/__webpack_require__.n(ThumbUpOutlined24_namespaceObject);
;// CONCATENATED MODULE: external "@andes/icons/ThumbDownOutlined24"
const ThumbDownOutlined24_namespaceObject = require("@andes/icons/ThumbDownOutlined24");
var ThumbDownOutlined24_default = /*#__PURE__*/__webpack_require__.n(ThumbDownOutlined24_namespaceObject);
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/labels-for-values.js
const POSITIVE = 'positive';
const NEGATIVE = 'negative';
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/client-storage.js
const FEEDBACK_LS_KEY = '__dx-feedback-thumbs-ls__';
function lskey() {
  try {
    return "".concat(FEEDBACK_LS_KEY, "@").concat(window.location.pathname);
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
function clientSaveFeedback(v) {
  try {
    const key = lskey();
    if (key) {
      window.localStorage.setItem(key, v);
    }
  } catch (error) {
    console.error(error);
  }
}
function clientResumeFeedback() {
  try {
    const key = lskey();
    if (key) {
      return window.localStorage.getItem(key);
    }
    return undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/Thumbs/index.js
var _ThumbUpOutlined, _ThumbDownOutlined;
var Thumbs_REACT_ELEMENT_TYPE;
function Thumbs_jsx(e, r, E, l) { Thumbs_REACT_ELEMENT_TYPE || (Thumbs_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: Thumbs_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }







function Thumbs(_ref) {
  let {
    isCard,
    onClickPositive,
    onClickNegative
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const [value, setValue] = (0,external_react_namespaceObject.useState)(clientResumeFeedback());
  (0,external_react_namespaceObject.useEffect)(() => {
    clientSaveFeedback(value);
  }, [value]);
  return /*#__PURE__*/Thumbs_jsx("div", {
    className: "thumbs",
    "data-card": isCard
  }, void 0, /*#__PURE__*/Thumbs_jsx("div", {
    className: "thumbs__header"
  }, void 0, /*#__PURE__*/Thumbs_jsx("p", {}, void 0, i18n.gettext('¿Te sirvió este contenido?'))), /*#__PURE__*/Thumbs_jsx("div", {
    className: "thumbs__body"
  }, void 0, /*#__PURE__*/Thumbs_jsx(button_namespaceObject.Button, {
    hierarchy: value === POSITIVE ? 'loud' : 'quiet',
    onClick: () => {
      setValue(POSITIVE);
      onClickPositive(POSITIVE);
    }
  }, void 0, _ThumbUpOutlined || (_ThumbUpOutlined = /*#__PURE__*/Thumbs_jsx((ThumbUpOutlined24_default()), {})), i18n.gettext('Sí')), /*#__PURE__*/Thumbs_jsx(button_namespaceObject.Button, {
    hierarchy: value === NEGATIVE ? 'loud' : 'quiet',
    onClick: () => {
      setValue(NEGATIVE);
      onClickNegative(NEGATIVE);
    }
  }, void 0, _ThumbDownOutlined || (_ThumbDownOutlined = /*#__PURE__*/Thumbs_jsx((ThumbDownOutlined24_default()), {})), i18n.gettext('No'))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/getDateInfo.js
function getDateInfo() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const yyyy = now.getFullYear();
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');
  return {
    date: "".concat(dd, "/").concat(mm, "/").concat(yyyy),
    month: String(mm),
    year: String(yyyy),
    hour: "".concat(hh, ":").concat(min, ":").concat(ss)
  };
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/data-store.js
function data_store_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function data_store_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? data_store_ownKeys(Object(t), !0).forEach(function (r) { data_store_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : data_store_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function data_store_defineProperty(e, r, t) { return (r = data_store_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function data_store_toPropertyKey(t) { var i = data_store_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function data_store_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class FeedbackPayload {
  constructor() {
    data_store_defineProperty(this, "config", {});
    data_store_defineProperty(this, "payload", {});
  }
  init(value, config) {
    var _config$lang;
    this.config = data_store_objectSpread({}, config || {});
    this.payload = data_store_objectSpread(data_store_objectSpread({}, getDateInfo()), {}, {
      value,
      validator: 'FeedbackThumbs',
      language: config === null || config === void 0 || (_config$lang = config.lang) === null || _config$lang === void 0 ? void 0 : _config$lang.toUpperCase(),
      url: (config === null || config === void 0 ? void 0 : config.url) || window.location.href,
      satisfaction: value,
      metrics_id: null,
      key: 'evaluation',
      category: 'DOCS_SATISFACTION',
      userId: config === null || config === void 0 ? void 0 : config.userId,
      siteid: config === null || config === void 0 ? void 0 : config.siteId,
      additional_info: {
        comment: '',
        reasons: [],
        email_agreement: false,
        name: '',
        email: ''
      }
    });
  }
}

// Payload$ = Payload Singleton
const store = new FeedbackPayload();
;// CONCATENATED MODULE: external "@andes/modal"
const modal_namespaceObject = require("@andes/modal");
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/feedback-reasons.js
/**
 * The database must deal with the reasons as keys, so the reasons
 * must be always in no-vocal spanish. The frontend is responsible
 * to each key translation, but the backend deals with every option
 * as a unique key.
 */

const positiveReasons = ['Fue fácil de entender', 'Encontré lo que buscaba', 'Resolvió mi problema', 'Me brindó información útil', 'Me ayudó con recursos y ejemplos', 'Otro'];
const negativeReasons = ['Fue difícil de entender', 'No encontré lo que buscaba', 'No resolvió mi problema', 'No tenía recursos ni ejemplos útiles', 'Tenía errores en los códigos', 'Otro'];
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/Honeypot/index.js
var Honeypot_div;
var Honeypot_REACT_ELEMENT_TYPE;
function Honeypot_jsx(e, r, E, l) { Honeypot_REACT_ELEMENT_TYPE || (Honeypot_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: Honeypot_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function Honeypot() {
  return Honeypot_div || (Honeypot_div = /*#__PURE__*/Honeypot_jsx("div", {
    className: "fildsNoH0N3Y-container"
  }, void 0, /*#__PURE__*/Honeypot_jsx("label", {
    className: "fildsNoH0N3Y",
    htmlFor: "name"
  }, void 0, /*#__PURE__*/Honeypot_jsx("input", {
    className: "fildsNoH0N3Y",
    autoComplete: "off",
    type: "text",
    id: "name",
    name: "name"
  })), /*#__PURE__*/Honeypot_jsx("label", {
    className: "fildsNoH0N3Y",
    htmlFor: "email"
  }, void 0, /*#__PURE__*/Honeypot_jsx("input", {
    className: "fildsNoH0N3Y",
    autoComplete: "off",
    type: "email",
    id: "email",
    name: "email"
  }))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/TellMeWhy/index.js
var _Honeypot, _ProgressIndicatorCir;
var TellMeWhy_REACT_ELEMENT_TYPE;
function TellMeWhy_jsx(e, r, E, l) { TellMeWhy_REACT_ELEMENT_TYPE || (TellMeWhy_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: TellMeWhy_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }









function TellMeWhy(_ref) {
  let {
    onClickNext,
    onSendError,
    onClickCancel,
    feedbackValue
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const [loading, setLoading] = (0,external_react_namespaceObject.useState)(false);
  const [selected, setSelected] = (0,external_react_namespaceObject.useState)(null);
  const reasons = feedbackValue === POSITIVE ? positiveReasons : negativeReasons;
  const onSubmit = e => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    store.payload.additional_info.reasons = [selected];

    // honeypot check ------------------------------------------------
    if (formData.get('name') || formData.get('email')) {
      store.payload.additional_info.name = formData.get('name');
      store.payload.additional_info.email = formData.get('email');
      store.payload.metrics_id = '000000';
      onClickNext(false);
      return;
    }
    // ---------------------------------------------------------------

    store.config.onSendReasons(store.payload).then(_ref2 => {
      let {
        metrics_id
      } = _ref2;
      /*
        the first request sends us the "id" of the feedback, which
        in the lib we call "metrics_id" to track the put on the
        second (comment) request.
      */
      store.payload.metrics_id = metrics_id;
      return metrics_id ? onClickNext() : onSendError();
    }).catch(error => {
      console.error(error);
      onSendError();
    });
  };
  return /*#__PURE__*/TellMeWhy_jsx("div", {
    className: "tell-me-why"
  }, void 0, /*#__PURE__*/TellMeWhy_jsx("h2", {}, void 0, i18n.gettext('Contanos por qué')), /*#__PURE__*/TellMeWhy_jsx("form", {
    onSubmit: onSubmit
  }, void 0, _Honeypot || (_Honeypot = /*#__PURE__*/TellMeWhy_jsx(Honeypot, {})), /*#__PURE__*/TellMeWhy_jsx("div", {
    className: "form__controls"
  }, void 0, /*#__PURE__*/TellMeWhy_jsx(radio_button_namespaceObject.RadioGroup, {
    value: selected,
    onChange: e => setSelected(e.target.value)
  }, void 0, reasons.map(item => /*#__PURE__*/TellMeWhy_jsx((radio_button_default()), {
    value: item,
    label: (_store$config => {
      if (item === 'No encontré lo que buscaba' && store !== null && store !== void 0 && (_store$config = store.config) !== null && _store$config !== void 0 && _store$config.lang && store.config.lang.toLowerCase() === 'es') {
        // temporary i18n fix
        return ['No encontré lo que buscaba'][0];
      }
      return i18n.gettext(item);
    })()
  })))), /*#__PURE__*/TellMeWhy_jsx("div", {
    className: "form__actions"
  }, void 0, loading ? _ProgressIndicatorCir || (_ProgressIndicatorCir = /*#__PURE__*/TellMeWhy_jsx(progress_indicator_circular_namespaceObject.ProgressIndicatorCircular, {
    size: "small"
  })) : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/TellMeWhy_jsx(button_namespaceObject.Button, {
    type: "submit",
    disabled: !selected || loading
  }, void 0, i18n.gettext('Enviar')), /*#__PURE__*/TellMeWhy_jsx(button_namespaceObject.Button, {
    type: "button",
    disabled: loading,
    hierarchy: "transparent",
    onClick: onClickCancel
  }, void 0, i18n.gettext('Cancelar'))))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/TellMeMore/index.js
var TellMeMore_Honeypot, TellMeMore_ProgressIndicatorCir;
var TellMeMore_REACT_ELEMENT_TYPE;
function TellMeMore_jsx(e, r, E, l) { TellMeMore_REACT_ELEMENT_TYPE || (TellMeMore_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: TellMeMore_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }










function TellMeMore(_ref) {
  let {
    onClickNext,
    onSendError
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const COMMENT_MAX_LENGTH = 300;
  const [comment, setComment] = (0,external_react_namespaceObject.useState)('');
  const [loading, setLoading] = (0,external_react_namespaceObject.useState)(false);
  const onSubmit = e => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    store.payload.additional_info.comment = normalizeComment(formData.get('comment'));
    store.payload.additional_info.email_agreement = Boolean(formData.get('email_agreement'));

    // honeypot check ------------------------------------------------
    if (formData.get('name') || formData.get('email')) {
      store.payload.additional_info.name = formData.get('name');
      store.payload.additional_info.email = formData.get('email');
      setLoading(false);
      onClickNext();
      return;
    }
    // ---------------------------------------------------------------

    store.config.onSendComment(store.payload).then(() => {
      setLoading(false);
      onClickNext();
    }).catch(error => {
      console.error(error);
      onSendError();
    });
  };
  return /*#__PURE__*/TellMeMore_jsx("div", {
    className: "tell-me-more",
    "data-min-words": countWords(comment) >= 3
  }, void 0, /*#__PURE__*/TellMeMore_jsx("h2", {}, void 0, i18n.gettext('Cuéntanos un poco más')), /*#__PURE__*/TellMeMore_jsx("form", {
    onSubmit: onSubmit
  }, void 0, TellMeMore_Honeypot || (TellMeMore_Honeypot = /*#__PURE__*/TellMeMore_jsx(Honeypot, {})), /*#__PURE__*/TellMeMore_jsx(textfield_namespaceObject.TextField, {
    multiline: true,
    countdown: true,
    name: "comment",
    disabled: loading,
    maxLength: COMMENT_MAX_LENGTH,
    onChange: e => setComment(e.target.value),
    helper: i18n.gettext('Incluye 3 palabras o más.'),
    label: i18n.gettext('Argumenta la opción que elegiste'),
    placeholder: i18n.gettext(store.payload.value === POSITIVE ? i18n.gettext('La página me sirvió porque...') : i18n.gettext('La página no me sirvió porque...'))
  }), /*#__PURE__*/TellMeMore_jsx("div", {
    className: "email-agreement"
  }, void 0, /*#__PURE__*/TellMeMore_jsx(checkbox_namespaceObject.Checkbox, {
    value: "true",
    disabled: loading,
    name: "email_agreement",
    label: i18n.gettext('Compartir mi e-mail para que puedan contactarme.')
  })), /*#__PURE__*/TellMeMore_jsx("div", {
    className: "form__actions"
  }, void 0, loading ? TellMeMore_ProgressIndicatorCir || (TellMeMore_ProgressIndicatorCir = /*#__PURE__*/TellMeMore_jsx(progress_indicator_circular_namespaceObject.ProgressIndicatorCircular, {
    size: "small"
  })) : /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, /*#__PURE__*/TellMeMore_jsx(button_namespaceObject.Button, {
    type: "submit",
    disabled: countWords(comment) < 3
  }, void 0, i18n.gettext('Enviar respuesta')), /*#__PURE__*/TellMeMore_jsx(button_namespaceObject.Button, {
    type: "button",
    hierarchy: "transparent",
    onClick: () => {
      var _store$config;
      if (store !== null && store !== void 0 && (_store$config = store.config) !== null && _store$config !== void 0 && _store$config.onSkipComment) {
        store.config.onSkipComment();
      }
      onClickNext();
    }
  }, void 0, i18n.gettext('No, gracias'))))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/icons/IconFinishVector.js
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse2, _ellipse3, _mask, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
var IconFinishVector_REACT_ELEMENT_TYPE;
function IconFinishVector_jsx(e, r, E, l) { IconFinishVector_REACT_ELEMENT_TYPE || (IconFinishVector_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: IconFinishVector_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function IconFinishVector() {
  return /*#__PURE__*/IconFinishVector_jsx("svg", {
    fill: "none",
    viewBox: "0 0 230 146",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/IconFinishVector_jsx("g", {
    clipPath: "url(#clip0_907_4452)"
  }, void 0, _path || (_path = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#000",
    fillOpacity: "0.04",
    fillRule: "evenodd",
    d: "M194.285 144.603c28.437-22.986 33.846-57.223 28.398-79.158-9.275-37.342-43.57-59.186-66.763-61.655-16.95-1.807-36.739 2.54-49.054 14.652-13.522 13.294-24.43 21.315-39.795 25.88-14.67 4.362-39.1 4.834-53.146 23.626-9.406 12.583-10.398 41.198-.489 57.828 7.213 12.103 24.978 18.466 25.552 18.827h155.297z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#5AD2FF",
    stroke: "#fff",
    strokeWidth: "1.6",
    d: "M124.889 15.92h0c-4.672-6.347-12.347-8.985-20.113-7.873l20.113 7.872zm0 0c2.059 2.796 2.946 5.894 3.41 9.19.232 1.65.356 3.337.472 5.059l.036.53c.103 1.543.208 3.115.387 4.676h0m-4.305-19.456l4.305 19.456m0 0c.799 6.953 3.376 13.308 7.015 19.208l-7.015-19.208zm-39.65-15.306c3.042-6.234 8.3-11.03 15.232-12.022L89.544 20.07z"
  })), _path3 || (_path3 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.8",
    d: "M88.825 19.718c3.126-6.406 8.578-11.424 15.838-12.463 8.012-1.147 15.998 1.571 20.87 8.19 4.335 5.888 3.667 12.973 4.456 19.838.783 6.81 3.308 13.055 6.901 18.88 7.659 12.416 27.169 19.315 25.436 43.458-2.024 14.624-7.371 25.937-28.471 28.007-31.626 3.102-43.823-30.52-48.228-55.71-2.995-17.13-3.562-36.345 3.198-50.2z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M93.912 65.833s4.777.294 4.777-10.434c0-10.729 17.745-9.295 17.525-.955-.221 8.34 6.172 10.397 6.172 10.397l1.253 12.444-11.055 7.044-10.721-.212-6.737-6.14-1.49-6.082.276-6.062z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M107.691 72.96c-7.348-.44-9.994-10.287-9.994-10.287l.735-4.188 6.099 5.217 3.16 1.323 3.527-1.323 5.584-4.63 1.911 3.16s-3.674 11.17-11.022 10.729z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path5 || (_path5 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M93.912 65.833s4.777.294 4.777-10.434c0-10.729 17.745-9.295 17.525-.955-.221 8.34 6.172 10.397 6.172 10.397l1.253 12.444-11.055 7.044-10.721-.212-6.737-6.14-1.49-6.082.276-6.062z"
  })), _path6 || (_path6 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#5AD2FF",
    stroke: "#fff",
    strokeWidth: "1.764",
    d: "M142.257 155.22c-.022.166-.063.241-.095.277a1.2 1.2 0 01-.739.066l-.048-.011-.049-.005a54.02 54.02 0 00-21.177 1.829v.001c-.821.24-1.637.5-2.443.757l-.004.001c-2.848.907-5.557 1.764-8.351 1.812h0c-3.682.064-7.211-1.276-10.939-2.704l-.015-.005c-1.622-.621-3.28-1.257-4.963-1.765l-.003-.001c-5.261-1.568-11.29-2.46-16.795-1.388h-.002c-.299.059-.624.117-.89.115l-.04-.001a2.186 2.186 0 01.052-.831c2.51-6.893 2.66-13.779 2.812-20.793.025-1.165.05-2.334.087-3.507l.001-.044-.003-.044-1.311-18.94-.043-.615-.593-.171-20.123-5.803c.836-2.019 3.123-7.42 7.163-16.078h0c2.68-5.746 5.154-9.006 7.015-10.854 1.82-1.808 3.073-2.283 3.413-2.412l.014-.005h0l.04-.015h0l.01-.004 19.452-7.746c.38 1.803 1.37 5.615 3.513 9.082 2.284 3.697 5.963 7.122 11.674 7.122 5.796 0 9.199-3.74 11.147-7.71 1.831-3.731 2.465-7.815 2.673-9.69l16.646 4.528h0a18.74 18.74 0 0110.798 7.852 71.05 71.05 0 014.344 7.8l.003.005a2710.87 2710.87 0 007.523 15.387l-19.728 7.907c-.698-.735-2.024-.293-2.059.801l-.57 18.134-.001.029.001.028c.304 9.255 1.178 17.765 2.551 26.707l.002.009c.057.348.082.654.05.893z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M142.05 90.403l2.134 18.427-2.256.904-.799-1.287.921-18.044zM74.275 90.403L72.14 108.83l2.257.904h1.99l-2.112-19.33z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path7 || (_path7 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M150.882 77.041a72.133 72.133 0 014.399 7.898 2765.573 2765.573 0 007.661 15.668.587.587 0 01-.309.805l-20.226 8.107a.59.59 0 01-.716-.231l-.553-.874-.603 19.168c.303 9.215 1.173 17.69 2.542 26.602.122.741.171 1.645-.448 2.068a2.084 2.084 0 01-1.401.171 53.12 53.12 0 00-20.831 1.8c-.81.237-1.618.494-2.427.752-2.826.9-5.658 1.803-8.604 1.853-3.882.068-7.573-1.345-11.27-2.761-1.632-.625-3.265-1.251-4.917-1.75-5.19-1.547-11.063-2.402-16.375-1.368-.578.114-1.637.31-1.89-.219a3.07 3.07 0 010-1.629c2.881-7.882 2.602-15.735 2.86-24.061l-1.312-18.94-20.444-5.895a.582.582 0 01-.379-.78c.716-1.742 3.034-7.266 7.308-16.426 5.426-11.632 10.111-13.412 10.928-13.722l.037-.014 19.756-7.867c.353-.14.75.083.823.456.634 3.2 3.803 15.806 14.386 15.806 10.644 0 12.646-13.604 12.976-16.922a.61.61 0 01.763-.532l16.958 4.613a19.625 19.625 0 0111.308 8.224z"
  })), _path8 || (_path8 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M48.6 121.826l8.596-17.222 16.651 4.82-7.08 13.387 18.52 4.462h.17s10.85-3.917 13.083-3.542c2.012.334 9.368 5.219 10.81 6.188a.95.95 0 01.351.448 1.582 1.582 0 01-.88 2.003l-.155.057.065.22c.092.284.13.582.114.88a1.057 1.057 0 01-1.971.456l.277.496c.115.2.168.43.154.66v.448a1.205 1.205 0 01-.814 1.074 1.199 1.199 0 01-1.263-.325c-.937-1.026-2.949-3.086-4.318-3.314a33.718 33.718 0 00-4.448-.22 1.496 1.496 0 00-1.401.961c.815.057 6.444 2.996 8.44 4.071a2.1 2.1 0 011.157 1.629c.073.618-.236 1.278-1.475.985a55.208 55.208 0 01-7.421-2.809s-2.444-.701-4.074.423c-2.24 1.58-3.258 2.158-5.197 1.523a16.417 16.417 0 01-2.447-1.048l-24.225 1.406a12.536 12.536 0 01-12.522-11.921 12.645 12.645 0 011.304-6.196z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M54.821 109.407l2.242-4.813 16.974 4.813-2.021 3.601-17.195-3.601z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path9 || (_path9 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M48.6 121.826l8.596-17.222 16.651 4.82-7.08 13.387 18.52 4.462h.17s10.85-3.917 13.083-3.542c2.012.334 9.368 5.219 10.81 6.188a.95.95 0 01.351.448 1.582 1.582 0 01-.88 2.003l-.155.057.065.22c.092.284.13.582.114.88a1.057 1.057 0 01-1.971.456l.277.496c.115.2.168.43.154.66v.448a1.205 1.205 0 01-.814 1.074 1.199 1.199 0 01-1.263-.325c-.937-1.026-2.949-3.086-4.318-3.314a33.718 33.718 0 00-4.448-.22 1.496 1.496 0 00-1.401.961c.815.057 6.444 2.996 8.44 4.071a2.1 2.1 0 011.157 1.629c.073.618-.236 1.278-1.475.985a55.208 55.208 0 01-7.421-2.809s-2.444-.701-4.074.423c-2.24 1.58-3.258 2.158-5.197 1.523a16.417 16.417 0 01-2.447-1.048l-24.225 1.406a12.536 12.536 0 01-12.522-11.921 12.645 12.645 0 011.304-6.196z"
  })), _path10 || (_path10 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M66.741 122.798s-3.092-.964-7.536.439c-4.443 1.403-5.816 3.827-5.816 3.827"
  })), _path11 || (_path11 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M173.268 131.434c-5.793-14.323-11.161-29.794-11.161-29.794l-15.3 6.156 7.504 16.741-14.507 3.078h-4.092s-10.851-3.917-13.084-3.542c-2.012.334-9.368 5.219-10.81 6.188a.885.885 0 00-.351.44 1.627 1.627 0 00.88 2.003l.155.065-.073.22a2.67 2.67 0 00-.106.88 1.057 1.057 0 001.971.456l-.277.488c-.111.202-.164.43-.154.66v.447a1.21 1.21 0 00.814 1.083 1.196 1.196 0 001.263-.333c.937-1.026 2.949-3.078 4.31-3.306a31.294 31.294 0 014.456-.22 1.495 1.495 0 011.401.961c-.815.057-6.444 2.996-8.44 4.071a2.147 2.147 0 00-1.165 1.628c-.073.627.244 1.279 1.483.994a54.874 54.874 0 007.421-2.809s2.444-.709 4.074.415c2.248 1.588 3.258 2.166 5.197 1.523l.24-.082h32.395c.436.009.87-.032 1.296-.122a6.271 6.271 0 004.003-2.673 6.282 6.282 0 00.934-4.72 6.07 6.07 0 00-.277-.896z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M164.087 107.276l-2.075-5.345-15.854 5.786 2.021 3.601 15.908-4.042z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path12 || (_path12 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M173.268 131.434c-5.793-14.323-11.161-29.794-11.161-29.794l-15.3 6.156 7.504 16.741-14.507 3.078h-4.092s-10.851-3.917-13.084-3.542c-2.012.334-9.368 5.219-10.81 6.188a.885.885 0 00-.351.44 1.627 1.627 0 00.88 2.003l.155.065-.073.22a2.67 2.67 0 00-.106.88 1.057 1.057 0 001.971.456l-.277.488c-.111.202-.164.43-.154.66v.447a1.21 1.21 0 00.814 1.083 1.196 1.196 0 001.263-.333c.937-1.026 2.949-3.078 4.31-3.306a31.294 31.294 0 014.456-.22 1.495 1.495 0 011.401.961c-.815.057-6.444 2.996-8.44 4.071a2.147 2.147 0 00-1.165 1.628c-.073.627.244 1.279 1.483.994a54.874 54.874 0 007.421-2.809s2.444-.709 4.074.415c2.248 1.588 3.258 2.166 5.197 1.523l.24-.082h32.395c.436.009.87-.032 1.296-.122a6.271 6.271 0 004.003-2.673 6.282 6.282 0 00.934-4.72 6.07 6.07 0 00-.277-.896zM79.018 148.957a45.358 45.358 0 013.995-.912 76.078 76.078 0 013.651-.583c1.58-.216 3.382-.42 5.428-.598m8.524-.504c1.352-.048 2.775-.084 4.271-.108a261.887 261.887 0 017.974 0c1.451.024 2.832.06 4.147.108 1.761.064 3.403.147 4.932.247 1.466.095 2.829.205 4.095.326 1.685.16 3.197.339 4.552.529a73.47 73.47 0 013.575.583M136.89 145.298a45.058 45.058 0 00-4.01-.845 76.574 76.574 0 00-3.66-.523 111.316 111.316 0 00-5.438-.506m-8.53-.362a215.744 215.744 0 00-4.273-.036 259.866 259.866 0 00-7.973.133c-1.45.048-2.831.108-4.144.177m-17.124 1.973a73.543 73.543 0 013.565-.644c1.352-.212 2.86-.416 4.542-.605"
  })), _path13 || (_path13 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M154.216 124.565s3.092-.964 7.536.439c4.443 1.403 5.816 3.827 5.816 3.827M107.01 134.197s-1.911-3.261-5.217-4.73c-3.307-1.47-6.724-.368-6.724-.368M108.627 132.36s-1.929-3.169-5.548-5.006c-3.619-1.837-6.926-.9-6.926-.9M114.249 134.399s1.91-3.26 5.217-4.73c3.307-1.47 6.723-.367 6.723-.367M112.587 132.53s1.929-3.169 5.548-5.006c3.618-1.837 6.925-.9 6.925-.9M73.668 85.085l2.793 25.015.166 2.396M142.226 87.583l-1.088 20.831-.071 2.24"
  })), _path14 || (_path14 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M8.366 150.741c0 .943.441 1.707.986 1.709l204.694.525c.543.001.984-.754.99-1.692l.055-9.491c.005-.95-.439-1.726-.988-1.726H9.353c-.545 0-.987.765-.987 1.709v8.966z"
  })), _path15 || (_path15 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M8.366 150.741c0 .943.441 1.707.986 1.709l204.694.525c.543.001.984-.754.99-1.692l.055-9.491c.005-.95-.439-1.726-.988-1.726H9.353c-.545 0-.987.765-.987 1.709v8.966z"
  })), _path16 || (_path16 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M73.069 135.492c0 2.406 1.831 4.356 4.09 4.356h62.935c2.259 0 4.09-1.95 4.09-4.356H73.069z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "1.764",
    d: "M137.299 100.686h-.011v36.639c0 .869-.69 1.55-1.513 1.55H81.467c-.823 0-1.513-.681-1.513-1.55V99.891c0-.532.422-.941.915-.941h55.516c.492 0 .914.409.914.941v.795z"
  })), _ellipse || (_ellipse = /*#__PURE__*/IconFinishVector_jsx("ellipse", {
    cx: "108.627",
    cy: "118.887",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: "0.882",
    rx: "5.02",
    ry: "5.096"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M79.631 133.455v3.87c0 1.343 1.073 2.432 2.395 2.432h54.308c1.323 0 2.395-1.089 2.395-2.432v-3.862c-.004 1.339-1.075 2.423-2.395 2.423H82.026c-1.322 0-2.395-1.089-2.395-2.431zM138.729 101.576h.011v-1.685c0-.067-.004-.134-.011-.2v1.885z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path18 || (_path18 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M79.072 99.891c0-1.007.804-1.823 1.796-1.823h55.517c.992 0 1.796.816 1.796 1.823v1.685h-.011v35.749c0 1.343-1.072 2.432-2.395 2.432H81.467c-1.323 0-2.395-1.089-2.395-2.432V99.891z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M42.125 140.069l2.419-31.006H23.602l2.419 31.006h16.104z",
    clipRule: "evenodd"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M42.45 136.312a23.45 23.45 0 01-8.394 1.528 23.48 23.48 0 01-8.397-1.527l.279 3.574h16.234l.279-3.575z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path20 || (_path20 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M42.125 140.069l2.419-31.006H23.602l2.419 31.006h16.104z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#5AD2FF",
    stroke: "#fff",
    strokeWidth: "1.764",
    d: "M42.842 128.891a.294.294 0 01-.293.267H25.465a.294.294 0 01-.293-.272l-.844-11.349a.294.294 0 01.293-.316h18.974c.173 0 .309.149.293.321l-1.046 11.349z"
  })), _path22 || (_path22 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M42.549 130.04c.608 0 1.115-.463 1.17-1.068l1.047-11.349a1.176 1.176 0 00-1.17-1.284H24.62c-.683 0-1.223.581-1.172 1.263l.844 11.349a1.176 1.176 0 001.172 1.089H42.55z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M41.514 104.604H26.632c-.365 0-.7.203-.866.528l-2.164 4.21h20.942l-2.163-4.21a.975.975 0 00-.867-.528z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M45.038 112.064H23.2c-.358 0-.648-.398-.648-.888v-1.894c0-.491.29-.888.648-.888h21.838c.358 0 .649.397.649.888v1.894c0 .49-.29.888-.649.888zM218.778 101.904l-31.909 32.078 2.475 2.483 31.909-32.078-2.475-2.483z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M221.321 103.109l-27.918-28.067-2.482 2.49 27.919 28.066 2.481-2.489z",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/IconFinishVector_jsx("ellipse", {
    cx: "3.634",
    cy: "3.641",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: "0.882",
    rx: "3.634",
    ry: "3.641",
    transform: "matrix(-1 0 0 1 223.04 100.705)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/IconFinishVector_jsx("ellipse", {
    cx: "6.863",
    cy: "6.878",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: "0.882",
    rx: "6.863",
    ry: "6.878",
    transform: "matrix(-1 0 0 1 188.587 83.443)"
  })), _mask || (_mask = /*#__PURE__*/IconFinishVector_jsx("mask", {
    id: "path-45-inside-1_907_4452",
    fill: "#fff"
  }, void 0, /*#__PURE__*/IconFinishVector_jsx("path", {
    d: "M195.847 81.239a13.635 13.635 0 01-2.592 15.743 13.698 13.698 0 01-4.324 2.913l-17.84-18.313a13.637 13.637 0 012.757-3.93c4.276-4.26 10.673-5.12 15.805-2.582l1.685-1.678.009-.009a4.36 4.36 0 016.175 0 4.382 4.382 0 01-.034 6.22l-1.641 1.636z"
  }))), _path26 || (_path26 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#5AD2FF",
    d: "M195.847 81.239a13.635 13.635 0 01-2.592 15.743 13.698 13.698 0 01-4.324 2.913l-17.84-18.313a13.637 13.637 0 012.757-3.93c4.276-4.26 10.673-5.12 15.805-2.582l1.685-1.678.009-.009a4.36 4.36 0 016.175 0 4.382 4.382 0 01-.034 6.22l-1.641 1.636z"
  })), _path27 || (_path27 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M195.847 81.239l-1.579.787-.567-1.139.901-.897 1.245 1.249zm-2.592 15.743l-1.245-1.25 1.245 1.25zm-4.324 2.913l.689 1.624-1.11.471-.842-.864 1.263-1.23zm-17.84-18.313l-1.263 1.23-.848-.87.511-1.102 1.6.742zm2.757-3.93l1.244 1.25-1.244-1.25zm15.805-2.582l1.245 1.25-.894.89-1.132-.56.781-1.58zm1.685-1.678l1.252 1.242-.008.008-1.244-1.25zm.009-.009l1.249 1.246-1.249-1.246zm6.175 0l1.248-1.246-1.248 1.246zm0 6.187l-1.248-1.245 1.248 1.245zm-.034.034l-1.244-1.25.009-.01 1.235 1.26zm-.063.848c2.877 5.773 1.904 12.97-2.926 17.78l-2.489-2.5a11.87 11.87 0 002.258-13.706l3.157-1.574zm-2.926 17.78a15.45 15.45 0 01-4.879 3.287l-1.377-3.247a11.916 11.916 0 003.767-2.54l2.489 2.5zm-6.831 2.894l-17.84-18.313 2.526-2.461 17.841 18.313-2.527 2.461zM169.491 80.84a15.401 15.401 0 013.112-4.438l2.489 2.5a11.87 11.87 0 00-2.401 3.422l-3.2-1.484zm3.112-4.438c4.828-4.808 12.044-5.775 17.832-2.913l-1.563 3.162c-4.478-2.214-10.055-1.46-13.78 2.25l-2.489-2.498zm19.979-1.76l-1.684 1.678-2.489-2.5 1.684-1.677 2.489 2.499zm-2.496-2.492l.025-.025.011-.01c.001-.001 0 0 0 0l-.004.004-.019.018 2.497 2.492-.024.023a.04.04 0 00-.006.006.017.017 0 01-.003.003l.006-.006.021-.02-2.504-2.485zm.013-.013a6.123 6.123 0 018.671 0l-2.496 2.492a2.596 2.596 0 00-3.678 0l-2.497-2.492zm8.671 0a6.145 6.145 0 010 8.68l-2.496-2.492a2.618 2.618 0 000-3.696l2.496-2.492zm0 8.68a1.723 1.723 0 01-.047.046l-2.47-2.518.021-.02 2.496 2.491zm-4.168-.827l1.642-1.636 2.489 2.5-1.642 1.635-2.489-2.5z",
    mask: "url(#path-45-inside-1_907_4452)"
  })), _path28 || (_path28 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#333",
    d: "M195.848 81.239l-.394.197-.142-.285.225-.224.311.312zm-2.592 15.743l-.311-.312.311.312zm-4.323 2.913l.172.406-.278.118-.21-.216.316-.308zm-17.841-18.313l-.316.308-.211-.218.127-.275.4.185zm2.757-3.93l.312.312-.312-.312zm15.806-2.582l.311.313-.224.222-.282-.14.195-.395zm1.684-1.678l.313.31-.002.003-.311-.313zm.01-.009l.312.311-.312-.311zm6.174 0l.313-.311-.313.311zm0 6.187l-.312-.311.312.311zm-.033.034l-.311-.313.002-.002.309.315zm-1.247 1.438c2.63 5.278 1.739 11.855-2.676 16.253l-.622-.625a13.195 13.195 0 002.509-15.234l.789-.394zm-2.676 16.253a14.12 14.12 0 01-4.462 3.006l-.344-.811a13.261 13.261 0 004.184-2.82l.622.625zm-4.95 2.908L170.776 81.89l.632-.615 17.841 18.313-.632.615zm-17.925-18.806a14.094 14.094 0 012.846-4.057l.623.624a13.206 13.206 0 00-2.669 3.804l-.8-.371zm2.846-4.057c4.414-4.397 11.016-5.284 16.312-2.665l-.39.79c-4.97-2.457-11.161-1.623-15.299 2.5l-.623-.625zm18.112-3.635l-1.684 1.677-.622-.624 1.684-1.678.622.625zm-.624-.623l.008-.008a.06.06 0 01.005-.005h.001l-.003.003.624.623-.008.007-.004.004c-.001 0 0 0 0 0l.003-.003-.626-.621zm.011-.01a4.8 4.8 0 016.799 0l-.625.622a3.918 3.918 0 00-5.55 0l-.624-.622zm6.799 0a4.824 4.824 0 010 6.81l-.625-.623a3.94 3.94 0 000-5.565l.625-.622zm0 6.81l-.037.036-.618-.629.03-.03.625.623zm-2.299 1.045l1.642-1.636.622.625-1.642 1.635-.622-.624z"
  })), _path29 || (_path29 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M175.11 140.067h35.577v-.625c0-3.192-2.339-5.778-5.223-5.778h-25.132c-2.884 0-5.222 2.586-5.222 5.778v.625zM181.547 133.663h22.096a4.48 4.48 0 00-4.477-4.486h-13.142a4.48 4.48 0 00-4.474 4.322l-.003.164z",
    clipRule: "evenodd"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M210.687 140.067H175.11c0-.826.223-1.599.612-2.264h34.352c.39.665.613 1.438.613 2.264zM203.117 133.663h-21.57c0-.826.223-1.599.612-2.264h20.346c.389.665.612 1.438.612 2.264z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path30 || (_path30 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M181.547 133.663h22.096a4.48 4.48 0 00-4.477-4.486h-13.142a4.48 4.48 0 00-4.474 4.322l-.003.164zM175.11 140.067h35.577v-.625c0-3.192-2.339-5.778-5.223-5.778h-25.132c-2.884 0-5.222 2.586-5.222 5.778v.625z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M92.198 37.648c-.616-.469-1.556-.977-2.497-.686-1.6.497-1.6 4.911-.772 6.896.827 1.986 3.144 3.531 3.917 3.531M124.602 37.648c.567-.469 1.434-.977 2.301-.686 1.475.497 1.475 4.911.712 6.896-.763 1.986-2.898 3.531-3.61 3.531",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M124.602 37.648c.567-.469 1.434-.977 2.301-.686 1.475.497 1.475 4.911.712 6.896-.763 1.986-2.898 3.531-3.61 3.531M92.198 37.648c-.616-.469-1.556-.977-2.497-.686-1.6.497-1.6 4.911-.772 6.896.827 1.986 3.144 3.531 3.917 3.531"
  })), _path33 || (_path33 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M91.924 35.177l.848 13.014a12.35 12.35 0 003.123 7.341c3.481 3.877 9.332 9.807 12.536 9.807 3.19 0 9.002-5.884 12.484-9.76a12.343 12.343 0 003.129-7.453l.77-12.949s1.088-19.455-16.487-19.455c-17.576 0-16.403 19.455-16.403 19.455z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M91.924 35.177l.848 13.014a12.35 12.35 0 003.123 7.341c3.481 3.877 9.332 9.807 12.536 9.807 3.19 0 9.002-5.884 12.484-9.76a12.343 12.343 0 003.129-7.453l.77-12.949s1.088-19.455-16.487-19.455c-17.576 0-16.403 19.455-16.403 19.455z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#5AD2FF",
    fillRule: "evenodd",
    d: "M107.926 32.487c8.458-6.921 7.467-16.918 7.467-16.918s-6-2.786-8.683-2.786c-10.06 0-18.107 8.047-18.778 15.09-.67 3.688 1.317 9.42 1.317 9.42s10.217 2.114 18.677-4.806z",
    clipRule: "evenodd"
  })), /*#__PURE__*/IconFinishVector_jsx("mask", {
    style: {
      maskType: 'luminance'
    },
    width: "29",
    height: "26",
    x: "87",
    y: "12",
    maskUnits: "userSpaceOnUse"
  }, void 0, _path36 || (_path36 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M107.926 32.487c8.458-6.921 7.467-16.918 7.467-16.918s-6-2.786-8.683-2.786c-10.06 0-18.107 8.047-18.778 15.09-.67 3.688 1.317 9.42 1.317 9.42s10.217 2.114 18.677-4.806z",
    clipRule: "evenodd"
  }))), _path37 || (_path37 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M89.249 37.293s10.217 2.114 18.677-4.806c8.458-6.921 7.467-16.918 7.467-16.918M111.895 49.817v0c-1.99.673-4.147.77-6.197.28l-.857-.204"
  })), _path38 || (_path38 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M87.144 33.779c-.814.174-2.934.887-2.876 1.76l.603 9.43c.058.873 2.163.81 2.977.867l-.704-11.999v-.058zM92.837 45.482l-.755-11.878c-.058-1.34-1.22-2.33-2.498-2.213-1.279.058-2.266 1.165-2.208 2.446v.058l.755 11.82v.116c.058 1.34 1.22 2.33 2.498 2.213 1.337-.117 2.324-1.281 2.208-2.562z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M92.605 43.62c-.116 1.164-.988 2.095-2.208 2.212-1.104.058-2.091-.64-2.382-1.63l.116 1.513v.117c.058 1.339 1.22 2.329 2.498 2.212a2.312 2.312 0 002.208-2.503l-.116-1.805c0-.117-.058-.117-.116-.117z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path39 || (_path39 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M92.837 45.482l-.755-11.878c-.058-1.34-1.22-2.33-2.498-2.213-1.279.058-2.266 1.165-2.208 2.446v.058l.755 11.82v.116c.058 1.34 1.22 2.33 2.498 2.213 1.337-.117 2.324-1.281 2.208-2.562z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M129.671 33.779c.813.174 2.856.933 2.798 1.807l-.656 9.528c-.058.873-2.111.812-2.924.87l.84-12.147-.058-.058z"
  })), _path41 || (_path41 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M129.356 33.779l1.715.343c.813.175 1.452.932 1.394 1.805l-.523 8.502A1.688 1.688 0 01130.373 46l-1.484.179M87.38 33.702l-1.714.344c-.814.174-1.453.931-1.395 1.805l.523 8.5a1.689 1.689 0 001.569 1.573l1.485.18"
  })), _path42 || (_path42 = /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M123.978 45.482l.755-11.878c.058-1.34 1.22-2.33 2.499-2.213 1.278.058 2.265 1.165 2.207 2.446v.058l-.755 11.82v.116c-.058 1.34-1.22 2.33-2.498 2.213-1.336-.117-2.324-1.281-2.208-2.562z"
  })), /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#EEE",
    d: "M124.152 43.62c.117 1.164.988 2.095 2.208 2.212 1.104.058 2.092-.64 2.382-1.63l-.116 1.513v.117c-.058 1.339-1.22 2.329-2.498 2.212a2.312 2.312 0 01-2.208-2.503l.116-1.805c.058-.117.116-.117.116-.117z",
    style: {
      mixBlendMode: 'multiply'
    }
  }), _path43 || (_path43 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M123.978 45.482l.755-11.878c.058-1.34 1.22-2.33 2.499-2.213 1.278.058 2.265 1.165 2.207 2.446v.058l-.755 11.82v.116c-.058 1.34-1.22 2.33-2.498 2.213-1.336-.117-2.324-1.281-2.208-2.562z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/IconFinishVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "0.882",
    d: "M92.736 16.915s1.263-.107 1.846.45c.583.557.439 1.799.439 1.799M124.733 17.886s-1.263-.107-1.846.45c-.583.557-.439 1.799-.439 1.799M92.677 19.358c-2.43 4.871-2.606 10.221-2.589 12.034M124.773 20.357c2.012 4.583 2.19 9.345 2.182 11.034"
  }))), _defs || (_defs = /*#__PURE__*/IconFinishVector_jsx("defs", {}, void 0, /*#__PURE__*/IconFinishVector_jsx("clipPath", {
    id: "clip0_907_4452"
  }, void 0, /*#__PURE__*/IconFinishVector_jsx("path", {
    fill: "#fff",
    d: "M0 0H229V146H0z",
    transform: "translate(.5)"
  })))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/FinishView/index.js
var _IconFinishVector;
var FinishView_REACT_ELEMENT_TYPE;
function FinishView_jsx(e, r, E, l) { FinishView_REACT_ELEMENT_TYPE || (FinishView_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: FinishView_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }





function FinishView(_ref) {
  let {
    onClickFinish,
    onClickReport
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  return /*#__PURE__*/FinishView_jsx("div", {
    className: "finish-view"
  }, void 0, _IconFinishVector || (_IconFinishVector = /*#__PURE__*/FinishView_jsx(IconFinishVector, {})), /*#__PURE__*/FinishView_jsx("h2", {}, void 0, i18n.gettext('¡Gracias por tu feedback!')), /*#__PURE__*/FinishView_jsx("p", {}, void 0, i18n.gettext('Tu aporte nos ayudará a mejorar nuestra documentación.')), /*#__PURE__*/FinishView_jsx("div", {
    className: "form__actions"
  }, void 0, /*#__PURE__*/FinishView_jsx(button_namespaceObject.Button, {
    type: "button",
    onClick: onClickFinish
  }, void 0, i18n.gettext('Cerrar')), /*#__PURE__*/FinishView_jsx("a", {
    href: store.config.reportErrorURL,
    target: "_blank",
    rel: "noreferrer"
  }, void 0, /*#__PURE__*/FinishView_jsx(button_namespaceObject.Button, {
    type: "button",
    hierarchy: "quiet",
    onClick: () => {
      var _store$config;
      onClickReport();
      if (store !== null && store !== void 0 && (_store$config = store.config) !== null && _store$config !== void 0 && _store$config.onClickReport) {
        store.config.onClickReport();
      }
    }
  }, void 0, i18n.gettext('Reportar un error')))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/icons/IconErrorVector.js
var _svg;
var IconErrorVector_REACT_ELEMENT_TYPE;
function IconErrorVector_jsx(e, r, E, l) { IconErrorVector_REACT_ELEMENT_TYPE || (IconErrorVector_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: IconErrorVector_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }

function IconErrorVector() {
  return _svg || (_svg = /*#__PURE__*/IconErrorVector_jsx("svg", {
    fill: "none",
    viewBox: "0 0 147 149",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/IconErrorVector_jsx("path", {
    fill: "#000",
    fillOpacity: "0.04",
    fillRule: "evenodd",
    d: "M82.963 24.309c-9.315 1.13-19.441 5.92-24.65 13.956-5.721 8.82-10.65 14.483-18.374 18.841-7.374 4.164-22.17 8.401-27.533 20.243-6.68 14.744 3.992 28.628 20.798 35.165 18.78 7.307 51.6 10.331 75.861-7.055 23.722-17 23.641-42.642 16.921-56.288-9.318-18.92-30.277-26.41-43.023-24.862z",
    clipRule: "evenodd"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "3",
    d: "M35.574 103.269l.017-.774-.621-.461c-4.218-3.138-6.946-8.156-6.946-13.812 0-.916.071-1.814.209-2.69l.249-1.586-1.6-.14a3.3 3.3 0 01-1.633-5.967l1.176-.849-.808-1.204a12.99 12.99 0 01-2.206-7.265c0-7.21 5.846-13.056 13.057-13.056 4.41 0 8.31 2.185 10.676 5.538l.962 1.364 1.253-1.101a12.903 12.903 0 012.445-1.692l.877-.467-.088-.99a17.502 17.502 0 01-.04-.531v-.002c-.02-.335-.03-.673-.03-1.014 0-9.5 7.702-17.202 17.203-17.202 6.81 0 12.7 3.958 15.487 9.707l.722 1.489 1.411-.865a17.115 17.115 0 018.976-2.524c9.5 0 17.202 7.7 17.202 17.201 0 1.34-.153 2.644-.442 3.894l-.122.527.243.484a17.134 17.134 0 011.821 7.712c0 7.406-4.681 13.722-11.251 16.145l-1.309.483.387 1.34c.438 1.517.673 3.12.673 4.782 0 9.5-7.701 17.202-17.202 17.202-4.624 0-8.82-1.823-11.912-4.793l-1.039-.998-1.039.998a17.136 17.136 0 01-11.912 4.793c-1.948 0-3.817-.323-5.559-.918l-.516-.176-.509.197a13.39 13.39 0 01-4.837.897c-7.415 0-13.427-6.012-13.427-13.428 0-.089 0-.17.002-.248z"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "1.5",
    d: "M28.235 96.047a18.632 18.632 0 01-1.711-7.825c0-.994.078-1.97.227-2.922a4.8 4.8 0 01-2.38-8.678 14.49 14.49 0 01-2.46-8.101c0-8.04 6.517-14.556 14.557-14.556 4.918 0 9.266 2.439 11.902 6.174a14.41 14.41 0 012.729-1.889 18.641 18.641 0 01-.075-1.68c0-10.329 8.373-18.702 18.702-18.702 7.407 0 13.808 4.307 16.837 10.552a18.615 18.615 0 019.76-2.745c10.328 0 18.701 8.372 18.701 18.701 0 1.455-.167 2.872-.481 4.232a18.57 18.57 0 011.768 5.556m-86.1 25.21a18.807 18.807 0 003.864 3.863l-.003.28c0 8.244 6.683 14.928 14.927 14.928 1.896 0 3.71-.354 5.378-.998 1.895.647 3.928.998 6.043.998 5.027 0 9.59-1.984 12.951-5.211a18.638 18.638 0 0012.951 5.211c10.329 0 18.702-8.373 18.702-18.702 0-1.803-.255-3.548-.732-5.198a18.764 18.764 0 0010.43-9.533m1.771-6.931a18.696 18.696 0 01-.456 3.171M43.476 71.195c0-7.94 6.435-14.375 14.374-14.375M96.744 62.626c0-7.938-6.435-14.374-14.374-14.374M37.873 82.494c0-7.938 6.436-14.374 14.374-14.374M77.058 95.094a9.054 9.054 0 01-12.367-3.313M34.224 103.355c2.203 1.485 5.265 2.704 9.859 2.235M24.919 76.228c.703-.525 1.944-1.027 1.944-1.027M104.244 94.378c-.385-1.444-1.942-5.288-5.192-7.538M10.427 45.715h12M45.06 14.465v12M22.621 23.473l8.485 8.485M112.281 119.445l8.486 8.486M114.031 112.959h6.736M105.861 122.195v6.736"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    fill: "#fff",
    d: "M115.278 17.257a3.834 3.834 0 00-.972-1.116 4.687 4.687 0 10-8.949-2.727 3.806 3.806 0 00-1.75-.057 4.689 4.689 0 10-8.25 3.993 3.809 3.809 0 00-1.97 5.344 3.808 3.808 0 003.057 6.655 4.686 4.686 0 005.456 2.232 5.69 5.69 0 0011.045-.735 4.688 4.688 0 006.279-5.237 4.687 4.687 0 00-3.946-8.352z"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "1.5",
    d: "M115.278 17.257a3.834 3.834 0 00-.972-1.116 4.687 4.687 0 10-8.949-2.727 3.806 3.806 0 00-1.75-.057 4.689 4.689 0 10-8.25 3.993 3.809 3.809 0 00-1.97 5.344 3.808 3.808 0 003.057 6.655 4.686 4.686 0 005.456 2.232 5.69 5.69 0 0011.045-.735 4.688 4.688 0 006.279-5.237 4.687 4.687 0 00-3.946-8.352zM96.744 24.705a3.808 3.808 0 01-3.808-3.807M111.975 15.345a3.808 3.808 0 012.134 6.96M107.336 35.59a5.687 5.687 0 005.488-7.188"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    fill: "#fff",
    d: "M1.414 102.231c0 1.035.328 1.994.887 2.777a2.728 2.728 0 104.181 3.418 4.79 4.79 0 108.416-4.388 2.728 2.728 0 10-4.181-3.418 4.792 4.792 0 00-9.303 1.611z"
  }), /*#__PURE__*/IconErrorVector_jsx("path", {
    stroke: "#333",
    strokeWidth: "1.5",
    d: "M1.414 102.231c0 1.035.328 1.994.887 2.777a2.728 2.728 0 104.181 3.418 4.79 4.79 0 108.416-4.388 2.728 2.728 0 10-4.181-3.418 4.792 4.792 0 00-9.303 1.611z"
  })));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/ErrorView/index.js
var _IconErrorVector;
var ErrorView_REACT_ELEMENT_TYPE;
function ErrorView_jsx(e, r, E, l) { ErrorView_REACT_ELEMENT_TYPE || (ErrorView_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ErrorView_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }





function ErrorView(_ref) {
  let {
    onClickReset,
    onClickFinish
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  (0,external_react_namespaceObject.useEffect)(() => {
    var _store$config;
    if ((_store$config = store.config) !== null && _store$config !== void 0 && _store$config.onErrorView) {
      store.config.onErrorView();
    }
  }, []);
  return /*#__PURE__*/ErrorView_jsx("div", {
    className: "error-view"
  }, void 0, _IconErrorVector || (_IconErrorVector = /*#__PURE__*/ErrorView_jsx(IconErrorVector, {})), /*#__PURE__*/ErrorView_jsx("h2", {}, void 0, i18n.gettext('Hubo un error al enviar tu feedback')), /*#__PURE__*/ErrorView_jsx("p", {}, void 0, i18n.gettext('Intenta de nuevo ahora o espera un momento para volver a intentarlo.')), /*#__PURE__*/ErrorView_jsx("div", {
    className: "form__actions"
  }, void 0, /*#__PURE__*/ErrorView_jsx(button_namespaceObject.Button, {
    type: "submit",
    onClick: () => {
      var _store$config2;
      onClickReset();
      if (store !== null && store !== void 0 && (_store$config2 = store.config) !== null && _store$config2 !== void 0 && _store$config2.onClickReset) {
        store.config.onClickReset();
      }
    }
  }, void 0, i18n.gettext('Intentar de nuevo')), /*#__PURE__*/ErrorView_jsx(button_namespaceObject.Button, {
    type: "button",
    hierarchy: "transparent",
    onClick: onClickFinish
  }, void 0, i18n.gettext('Cerrar'))));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/components/ModalReasons/index.js
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ModalReasons_REACT_ELEMENT_TYPE;
function ModalReasons_jsx(e, r, E, l) { ModalReasons_REACT_ELEMENT_TYPE || (ModalReasons_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: ModalReasons_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }







function ModalReasons(props) {
  const [step, setStep] = (0,external_react_namespaceObject.useState)(0);
  (0,external_react_namespaceObject.useEffect)(() => {
    var _store$config;
    if (props.open && (_store$config = store.config) !== null && _store$config !== void 0 && _store$config.onOpenModal) {
      store.config.onOpenModal();
      return () => store.config.onCloseModal();
    }
    return () => {};
  }, [props.open]);
  return /*#__PURE__*/external_react_default().createElement(modal_namespaceObject.Modal, _extends({
    srLabel: "",
    type: "small",
    closable: false,
    closeButtonSrLabel: "",
    className: "feedback-thumbs-modal"
  }, props), step === -1 && /*#__PURE__*/ModalReasons_jsx(ErrorView, {
    onClickFinish: props.onClose,
    onClickReset: () => {
      props.onReset();
      setStep(0);
    }
  }), step === 0 && /*#__PURE__*/ModalReasons_jsx(TellMeWhy, {
    onClickCancel: props.onClose,
    onSendError: () => setStep(-1),
    feedbackValue: props.feedbackValue,
    onClickNext: () => setStep(store.config.isLogged ? 1 : 2)
  }), step === 1 && /*#__PURE__*/ModalReasons_jsx(TellMeMore, {
    onClickNext: () => setStep(2),
    onSendError: () => setStep(-1)
  }), step === 2 && /*#__PURE__*/ModalReasons_jsx(FinishView, {
    onClickFinish: props.onClose,
    onClickReport: props.onClose
  }));
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/toolbox/i18n-configure.js

function getTranslations() {
  if (typeof window !== typeof undefined) {
    var _window$__PRELOADED_S;
    return ((_window$__PRELOADED_S = window.__PRELOADED_STATE__) === null || _window$__PRELOADED_S === void 0 ? void 0 : _window$__PRELOADED_S.translations) || {};
  }
  return {};
}
const i18n = new external_frontend_i18n_namespaceObject.I18n({
  translations: getTranslations()
});
;// CONCATENATED MODULE: ./src/FeedbackThumbs/index.js
var FeedbackThumbs_REACT_ELEMENT_TYPE;
function FeedbackThumbs_jsx(e, r, E, l) { FeedbackThumbs_REACT_ELEMENT_TYPE || (FeedbackThumbs_REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: FeedbackThumbs_REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }






const FeedbackThumbs = props => {
  const [value, setValue] = (0,external_react_namespaceObject.useState)();
  const [openModal, setOpenModal] = (0,external_react_namespaceObject.useState)(false);
  function initializeStore() {
    /**
     * Initializes the "store" singleton. Since this point, this object
     * acts like a non-reactive singleton, when you change this object,
     * all the other components can import the same ref with your changes
     */
    store.init(value, props);
  }
  const handleThumbClick = v => {
    var _store$config;
    setValue(v);
    setOpenModal(true);
    if ((_store$config = store.config) !== null && _store$config !== void 0 && _store$config.onClickThumb) {
      store.config.onClickThumb(v);
    }
  };

  // store main init
  initializeStore();
  return /*#__PURE__*/FeedbackThumbs_jsx(external_frontend_i18n_namespaceObject.I18nProvider, {
    i18n: i18n
  }, void 0, /*#__PURE__*/FeedbackThumbs_jsx("div", {
    className: "feedback-thumbs"
  }, void 0, /*#__PURE__*/FeedbackThumbs_jsx(Thumbs, {
    isCard: props.isCard,
    onClickPositive: handleThumbClick,
    onClickNegative: handleThumbClick
  }), /*#__PURE__*/FeedbackThumbs_jsx(ModalReasons, {
    open: openModal,
    feedbackValue: value,
    onReset: () => initializeStore(),
    onClose: () => setOpenModal(false)
  }, openModal)));
};
;// CONCATENATED MODULE: ./src/CSAT/validator.js


const validator_texts = texts_getTexts(i18nNOOP);
function validateCSAT() {
  let satisfaction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  try {
    if (!validator_texts[1].checkboxes[satisfaction]) {
      return false;
    }
    for (const reason of reasons) {
      var _texts$1$checkboxes$s;
      if (!((_texts$1$checkboxes$s = validator_texts[1].checkboxes[satisfaction]) !== null && _texts$1$checkboxes$s !== void 0 && _texts$1$checkboxes$s.find(item => item.name === reason))) {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.error('Error validating CSAT results: ', error);
    return false;
  }
}
;// CONCATENATED MODULE: ./src/FeedbackThumbs/validator.js



const FEEDBACK_CATEGORY = 'DOCS_SATISFACTION'; // i can get no
const FEEDBACK_KEY = 'evaluation';
function hasPayloadAndInfo(payload) {
  const result = !!(payload && payload.additional_info);
  console.debug('hasPayloadAndInfo:', result, payload);
  return result;
}
function isValidSatisfaction(payload) {
  const result = [POSITIVE, NEGATIVE].includes(payload.satisfaction);
  console.debug('isValidSatisfaction:', result, payload);
  return result;
}
function isValidValue(payload) {
  const result = [POSITIVE, NEGATIVE].includes(payload.value);
  console.debug('isValidValue:', result, payload);
  return result;
}
function isValidCategory(payload) {
  const result = payload.category === FEEDBACK_CATEGORY;
  console.debug('isValidCategory:', result, payload);
  return result;
}
function isValidKey(payload) {
  const result = payload.key === FEEDBACK_KEY;
  console.debug('isValidKey:', result, payload);
  return result;
}
function isValidReason(payload) {
  let result = false;
  if (payload.value === POSITIVE) {
    result = positiveReasons.includes(payload.additional_info.reasons[0]);
  } else if (payload.value === NEGATIVE) {
    result = negativeReasons.includes(payload.additional_info.reasons[0]);
  }
  console.debug('isValidReason:', result, payload);
  return result;
}
function isValidEmailAgreement(payload) {
  var _payload$additional_i;
  const result = payload !== null && payload !== void 0 && (_payload$additional_i = payload.additional_info) !== null && _payload$additional_i !== void 0 && _payload$additional_i.email_agreement ? typeof payload.additional_info.email_agreement === 'boolean' : true;
  console.debug('isValidEmailAgreement:', result, payload);
  return result;
}
function isValidDateFormat(payload) {
  const result = payload.date ? payload.date.match(/^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/) !== null : false;
  console.debug('isValidDateFormat:', result, payload);
  return result;
}
function isValidMonth(payload) {
  const months = Array(12).fill(null).map((_, i) => i + 1);
  const month = Number(payload === null || payload === void 0 ? void 0 : payload.month);
  const result = Boolean(month && String(month).length <= 2 && months.includes(month));
  console.debug('isValidMonth:', result, payload);
  return result;
}
function isValidHourFormat(payload) {
  const result = payload.hour.match(/^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/) !== null;
  console.debug('isValidHourFormat:', result, payload);
  return result;
}
function validator_isCommentValid(payload) {
  const {
    comment
  } = payload.additional_info;
  if (!comment) {
    console.debug('isCommentValid: true (no comment)', payload);
    return true;
  }
  const normalizedComment = normalizeComment(comment);
  const result = countWords(normalizedComment) >= 3;
  console.debug('isCommentValid:', result, payload);
  return result;
}
function isValidYear(payload) {
  const result = payload.year.match(/^\d{4}$/);
  console.debug('isValidYear:', result, payload);
  return result;
}
function isValidLanguage(payload) {
  const languages = ['pt', 'es', 'en'];
  const result = payload && payload.language && languages.includes(payload.language.toLowerCase());
  console.debug('isValidLanguage:', result, payload);
  return result;
}
function validator_isValidURL(payload) {
  const urlString = payload.url;
  const allowedSubdomains = ['www', 'dev', 'beta', 'omega', 'alpha'];
  const validDomain = 'mercadopago';
  try {
    const url = new URL(urlString);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      console.log('Protocolo inválido:', url.protocol);
      return false;
    }
    const domainParts = url.hostname.split('.');
    const domain = domainParts[1];
    const subdomain = domainParts[0];
    console.log('domainParts:', domain, subdomain);
    if (domain !== validDomain) {
      return false;
    }
    if (subdomain && !allowedSubdomains.includes(subdomain)) {
      return false;
    }
    return true;
  } catch (error) {
    console.error("Erro ao validar a URL: ".concat(urlString), error);
    return false;
  }
}
function validateFeedbackThumbs(payload) {
  const validators = [hasPayloadAndInfo, isValidSatisfaction, isValidValue, isValidCategory, isValidKey, isValidReason, isValidEmailAgreement, isValidDateFormat, isValidMonth, isValidHourFormat, validator_isCommentValid, isValidYear, isValidLanguage, validator_isValidURL];
  try {
    return validators.map(validator => validator(payload)).every(result => result);
  } catch (error) {
    console.error('An error occurred during validation:', error);
    return false;
  }
}
;// CONCATENATED MODULE: ./src/Feedback/validator.js


const Feedback_validator_texts = getTexts(i18nNOOP);
function validateFeedback() {
  let satisfaction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  try {
    if (!Feedback_validator_texts.some(item => item.checkboxes[satisfaction])) {
      return false;
    }
    for (const reason of reasons) {
      const ok = Feedback_validator_texts.map(item => item.checkboxes).some(subitem => {
        const corpus = subitem[satisfaction];
        if (Array.isArray(corpus)) {
          return corpus.some(checking => checking.name === reason);
        }
        return Object.values(corpus).flat().some(checking => checking.name === reason);
      });
      if (!ok) {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.error('Error validating Feedback results: ', error);
    return false;
  }
}
;// CONCATENATED MODULE: ./src/NPS/validator.js


const NPS_validator_texts = NPS_texts_getTexts(i18nNOOP);
function validateNPS(key, value) {
  const corpus = NPS_validator_texts.map(item => {
    var _item$question;
    return item === null || item === void 0 || (_item$question = item.question) === null || _item$question === void 0 ? void 0 : _item$question.name;
  });
  return corpus.includes(key) && !!Number(value);
}
;// CONCATENATED MODULE: ./src/HomologCSAT/validator.js


const HomologCSAT_validator_texts = HomologCSAT_texts_getTexts(i18nNOOP);
function validateHomologCSAT() {
  let satisfaction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  try {
    if (!HomologCSAT_validator_texts[1].checkboxes[satisfaction]) {
      return false;
    }
    for (const reason of reasons) {
      var _texts$1$checkboxes$s;
      if (!((_texts$1$checkboxes$s = HomologCSAT_validator_texts[1].checkboxes[satisfaction]) !== null && _texts$1$checkboxes$s !== void 0 && _texts$1$checkboxes$s.find(item => item.name === reason))) {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.error('Error validating CSAT results: ', error);
    return false;
  }
}
;// CONCATENATED MODULE: ./src/utils/validators.js







function isValidFeedbackCategory(category) {
  if (typeof category !== 'string') {
    return false;
  }
  return categories.includes(category);
}
;// CONCATENATED MODULE: ./src/utils/baseAPIURL.js
function getHost(urlHrefOrHost) {
  return urlHrefOrHost.startsWith('http') ? new URL(urlHrefOrHost).host : urlHrefOrHost;
}
function getScope(host) {
  return host.split('.')[0];
}
function isDevScope(scope) {
  return ['beta', 'omega', 'dev', 'alpha'].includes(scope);
}
function getDot(host) {
  if (host.includes('.com')) {
    return "com".concat(host.split('.com').slice(-1));
  }
  return host.split('.').slice(-1);
}

/**
 * Returns the Feedback API Base URL
 *
 * The Feedback Service API lives on the dx-panel-front-tools application API,
 * so all the other services must resolve the Feedback Server Base API URL to
 * this project. You must call this function under any mercadopago.* project
 * route to discover wherer to send requests for Feedback Sevice.
 *
 * Usage:
 *
 * Call the function and pass a URL Href (complete URL) or a Hostname, the
 * function will return the Feedback API Base URL based on your current location.
 *
 * E.g:
 *
 * getFeedbackBaseAPIURL('https://www.mercadopago.com.br');
 * getFeedbackBaseAPIURL('www.mercadopago.cl');
 *
 * @param { string } urlHrefOrHost
 * @returns { string }
 */
function getFeedbackBaseAPIURL(urlHrefOrHost) {
  const host = getHost(urlHrefOrHost);
  const scope = getScope(host);
  const dot = getDot(host);
  return isDevScope(scope) ? "https://".concat(scope, ".mercadopago.").concat(dot, "/developers/panel/test-users/api") : "https://www.mercadopago.".concat(dot, "/developers/panel/test-users/api");
}
;// CONCATENATED MODULE: ./src/index.js








module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=main.js.map